webpackJsonp([1],Array(93).concat([
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(264)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(145),
  /* template */
  __webpack_require__(258),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8eca63bc",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/home/jenkins/workspace/vue-reginalAgent/src/components/header.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] header.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-8eca63bc", Component.options)
  } else {
    hotAPI.reload("data-v-8eca63bc", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_login__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_register__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_register___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_register__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_download__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_download___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pages_download__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_runnability__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_runnability___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__pages_runnability__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_myService__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_myService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__pages_myService__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_taskRegister__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_taskRegister___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__pages_taskRegister__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_aliyunkfRegister__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_aliyunkfRegister___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__pages_aliyunkfRegister__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_providerRegister__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_providerRegister___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__pages_providerRegister__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_providerLogin__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_providerLogin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__pages_providerLogin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_providerHasLogin__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_providerHasLogin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__pages_providerHasLogin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_providerBankCard__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_providerBankCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__pages_providerBankCard__);


//登录

//注册

//下载

//代理管理




//合伙人注册登录





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__webpack_require__(266));

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  base: '/reginalAgent',
  routes: [{
    path: '/login',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_login___default.a,
    name: 'login',
    meta: {
      title: '区域代理-登录'
    }
  }, {
    path: '/register',
    component: __WEBPACK_IMPORTED_MODULE_3__pages_register___default.a,
    name: 'register',
    meta: {
      title: '注册淘金客'
    }
  }, {
    path: '/aliyunkfRegister',
    component: __WEBPACK_IMPORTED_MODULE_8__pages_aliyunkfRegister___default.a,
    name: 'aliyunkfRegister',
    meta: {
      title: '注册'
    }
  }, {
    path: '/providerRegister',
    component: __WEBPACK_IMPORTED_MODULE_9__pages_providerRegister___default.a,
    name: 'providerRegister',
    meta: {
      title: '注册'
    }
  }, {
    path: '/providerLogin',
    component: __WEBPACK_IMPORTED_MODULE_10__pages_providerLogin___default.a,
    name: 'providerLogin',
    meta: {
      title: '登录'
    }
  }, {
    path: '/providerHasLogin',
    component: __WEBPACK_IMPORTED_MODULE_11__pages_providerHasLogin___default.a,
    name: 'providerHasLogin',
    meta: {
      title: '修改资料'
    }
  }, {
    path: '/providerBankCard',
    component: __WEBPACK_IMPORTED_MODULE_12__pages_providerBankCard___default.a,
    name: 'providerBankCard',
    meta: {
      title: '绑定银行卡'
    }
  }, {
    path: '/download',
    component: __WEBPACK_IMPORTED_MODULE_4__pages_download___default.a,
    name: 'download',
    meta: {
      title: '下载淘金客'
    }
  }, {
    path: '/runnability',
    component: __WEBPACK_IMPORTED_MODULE_5__pages_runnability___default.a,
    name: 'runnability',
    meta: {
      title: '区域代理-运行情况'
    }
  }, {
    path: '/myService',
    component: __WEBPACK_IMPORTED_MODULE_6__pages_myService___default.a,
    name: 'myService',
    meta: {
      title: '区域代理-我的客服'
    }
  }, {
    path: '/taskRegister',
    component: __WEBPACK_IMPORTED_MODULE_7__pages_taskRegister___default.a,
    name: 'taskRegister',
    meta: {
      title: '注册'
    }
  }]
}));

/***/ }),
/* 95 */,
/* 96 */,
/* 97 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 98 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 99 */,
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(144),
  /* template */
  __webpack_require__(251),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/home/jenkins/workspace/vue-reginalAgent/src/App.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] App.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-52508dfd", Component.options)
  } else {
    hotAPI.reload("data-v-52508dfd", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(146),
  /* template */
  __webpack_require__(248),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/home/jenkins/workspace/vue-reginalAgent/src/components/pagination.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] pagination.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0c29ce2f", Component.options)
  } else {
    hotAPI.reload("data-v-0c29ce2f", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

__webpack_require__(226);
__webpack_require__(224);
__webpack_require__(225);
if (!window.Quill) {
  window.Quill = __webpack_require__(91);
}
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'quill-editor',
  data: function data() {
    return {
      _content: '',
      defaultModules: {
        toolbar: [['bold', 'italic', 'underline', 'strike'], ['blockquote', 'code-block'], [{ 'header': 1 }, { 'header': 2 }], [{ 'list': 'ordered' }, { 'list': 'bullet' }], [{ 'script': 'sub' }, { 'script': 'super' }], [{ 'indent': '-1' }, { 'indent': '+1' }], [{ 'direction': 'rtl' }], [{ 'size': ['small', false, 'large', 'huge'] }], [{ 'header': [1, 2, 3, 4, 5, 6, false] }], [{ 'color': [] }, { 'background': [] }], [{ 'font': [] }], [{ 'align': [] }], ['clean'], ['link', 'image', 'video']]
      }
    };
  },
  props: {
    content: String,
    value: String,
    disabled: Boolean,
    options: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    }
  },
  mounted: function mounted() {
    this.initialize();
  },
  beforeDestroy: function beforeDestroy() {
    this.quill = null;
  },
  methods: {
    initialize: function initialize() {
      if (this.$el) {

        // options and instance
        var self = this;
        self.options.theme = self.options.theme || 'snow';
        self.options.boundary = self.options.boundary || document.body;
        self.options.modules = self.options.modules || self.defaultModules;
        self.options.modules.toolbar = self.options.modules.toolbar !== undefined ? self.options.modules.toolbar : self.defaultModules.toolbar;
        self.options.placeholder = self.options.placeholder || 'Insert text here ...';
        self.options.readOnly = self.options.readOnly !== undefined ? self.options.readOnly : false;
        self.quill = new Quill(self.$refs.editor, self.options);

        // set editor content
        if (self.value || self.content) {
          self.quill.pasteHTML(self.value || self.content);
        }

        // mark model as touched if editor lost focus
        self.quill.on('selection-change', function (range) {
          if (!range) {
            self.$emit('blur', self.quill);
          } else {
            self.$emit('focus', self.quill);
          }
        });

        // update model if text changes
        self.quill.on('text-change', function (delta, oldDelta, source) {
          var html = self.$refs.editor.children[0].innerHTML;
          var text = self.quill.getText();
          if (html === '<p><br></p>') html = '';
          self._content = html;
          self.$emit('input', self._content);
          self.$emit('change', {
            editor: self.quill,
            html: html,
            text: text
          });
        });

        // disabled
        if (this.disabled) {
          this.quill.enable(false);
        }

        // emit ready
        self.$emit('ready', self.quill);
      }
    }
  },
  watch: {
    content: function content(newVal, oldVal) {
      if (this.quill) {
        if (!!newVal && newVal !== this._content) {
          this._content = newVal;
          this.quill.pasteHTML(newVal);
        } else if (!newVal) {
          this.quill.setText('');
        }
      }
    },
    value: function value(newVal, oldVal) {
      if (this.quill) {
        if (!!newVal && newVal !== this._content) {
          this._content = newVal;
          this.quill.pasteHTML(newVal);
        } else if (!newVal) {
          this.quill.setText('');
        }
      }
    },
    disabled: function disabled(newVal, oldVal) {
      if (this.quill) {
        this.quill.enable(!newVal);
      }
    }
  }
});

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  mounted: function mounted() {
    this.fnResize();
    var self = this;
    window.onresize = function () {
      self.fnResize();
    };
  },

  methods: {
    fnResize: function fnResize() {
      var deviceWidth = document.documentElement.clientWidth || window.innerWidth;
      if (deviceWidth >= 750) {
        deviceWidth = 750;
        $('body,#app,main').css('height', '100%');
      } else {
        $('body,#app,main').css('height', '100%');
      }
      if (deviceWidth <= 320) {
        deviceWidth = 320;
      }
      document.documentElement.style.fontSize = deviceWidth / 7.5 + 'px';
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  props: ['addActive'],
  methods: {
    logOut: function logOut() {
      var _this = this;

      this.$http.post({"system":"http://dl.itaojin.cn/reginalAgencyApi","systemHeader":"http://dl.itaojin.cn","statistics":"http://dl.itaojin.cn/tjkInfo","tjuser":"http://t.itaojin.cn/tjuser","provider":"http://dl.itaojin.cn/provider","RTY":"http://t.itaojin.cn/teamTalk/action"}.system + "/agency/logOut").then(function (response) {
        var result = response.data;
        if (result.success) {
          _this.delCookie('reginal_agency_token');
          _this.$router.push({ name: 'login' });
        } else {
          _this.$message({
            message: result.msg,
            type: 'success',
            center: true,
            duration: 1000
          });
        }
      }, function (response) {
        _this.$message({
          message: '网络繁忙，请稍后重试！',
          type: 'error',
          center: true,
          duration: 1000
        });
      });
    },
    delCookie: function delCookie(name) {
      var exp = new Date();
      exp.setTime(exp.getTime() - 1);
      var cval = this.getCookie(name);
      if (cval != null) window.document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
    },
    //读取cookies
    getCookie: function getCookie(name) {
      var arr,
          reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
      if (arr = window.document.cookie.match(reg)) return arr[2];else return null;
    }
  }
});

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'pagination',
  data: function data() {
    return {};
  },

  props: ['pages', 'pageNum'],
  computed: {
    prePage: function prePage() {
      return this.pageNum !== 1 && this.pages;
    },
    nextPage: function nextPage() {
      return this.pageNum < this.pages && this.pages;
    },
    showPageBtn: function showPageBtn() {
      var arr = [];
      if (this.pages <= 5) {
        for (var i = 1; i <= this.pages; i++) {
          arr.push(i);
        }
        return arr;
      }
      if (this.pageNum <= 2) return [1, 2, 3, 0, this.pages];
      if (this.pageNum >= this.pages - 1) return [1, 0, this.pages - 2, this.pages - 1, this.pages];
      if (this.pageNum === 3) return [1, 2, 3, 4, 0, this.pages];
      if (this.pageNum === this.pages - 2) return [1, 0, this.pages - 3, this.pages - 2, this.pages - 1, this.pages];
      return [1, 0, this.pageNum - 1, this.pageNum, this.pageNum + 1, 0, this.pages];
    }
  },
  methods: {
    goPrePage: function goPrePage() {
      this.$emit('getData', this.pageNum - 1);
    },
    pageOffset: function pageOffset(i) {
      this.$emit('getData', i);
    },
    goNextPage: function goNextPage() {
      this.$emit('getData', this.pageNum + 1);
    }
  }
});

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'aliyunkfRegister',
	data: function data() {
		return {
			'phone': '',
			'code': '',
			'password': '',
			'passwords': '',
			'timer': '',
			'click': true,
			'codeClick': true
		};
	},

	methods: {

		//验证码计时
		gainCode: function gainCode() {
			var txt = $('.code').text();
			if (txt == '获取' || txt == '重发') {
				clearInterval(this.timer);
				$('.code').text('60');
				var self = this;
				this.timer = setInterval(function () {
					var text = $('.code').text();
					if (text == 1) {
						$('.code').text('重发');
						self.codeClick = true;
						clearInterval(self.timer);
						return;
					} else {
						text--;
						self.codeClick = false;
						$('.code').text(text);
					}
				}, 1000);
			} else {
				return;
			}
		},
		//获取加密数据
		getSignature: function getSignature() {
			var _this = this;

			if (!this.codeClick) {
				return;
			}
			if (this.phone == '') {
				this.$message({
					message: "请填写手机号！",
					type: 'error',
					center: true,
					duration: 2000
				});
				return;
			} else if (this.phone.length != 11) {
				this.$message({
					message: "手机格式有误，请重新输入！",
					type: 'error',
					center: true,
					duration: 2000
				});
				return;
			}

			var data = {
				'phone': this.phone,
				'invitationCode': "123456"
			};
			this.$http.post({"system":"http://dl.itaojin.cn/reginalAgencyApi","systemHeader":"http://dl.itaojin.cn","statistics":"http://dl.itaojin.cn/tjkInfo","tjuser":"http://t.itaojin.cn/tjuser","provider":"http://dl.itaojin.cn/provider","RTY":"http://t.itaojin.cn/teamTalk/action"}.tjuser + '/register/getSignature', data).then(function (response) {
				var result = response.data;
				if (result.success) {
					_this.sendSms(result.data);
				} else {
					_this.$message({
						message: result.msg,
						type: 'error',
						center: true,
						duration: 2000
					});
				}
			}, function (response) {
				_this.$message({
					message: "网络繁忙，请稍后重试！",
					type: 'error',
					center: true,
					duration: 2000
				});
			});
		},
		//获取短信
		sendSms: function sendSms(sig) {
			var _this2 = this;

			var data = {
				signature: sig,
				phoneNumber: this.phone
			};
			this.$http.post({"system":"http://dl.itaojin.cn/reginalAgencyApi","systemHeader":"http://dl.itaojin.cn","statistics":"http://dl.itaojin.cn/tjkInfo","tjuser":"http://t.itaojin.cn/tjuser","provider":"http://dl.itaojin.cn/provider","RTY":"http://t.itaojin.cn/teamTalk/action"}.tjuser + "/register/sendSms", data).then(function (response) {
				var result = response.data;
				if (result.success) {
					_this2.$message({
						message: '发送成功',
						type: 'success',
						center: true,
						duration: 2000
					});
					_this2.gainCode();
				} else {
					_this2.$message({
						message: result.msg,
						type: 'error',
						center: true,
						duration: 2000
					});
					if (result.msg == '当前手机号已经注册') {
						clearInterval(_this2.timer);
						$('.code').text('重发');
					}
				}
			}, function (response) {
				_this2.$message({
					message: "网络繁忙，请稍后重试！",
					type: 'error',
					center: true,
					duration: 2000
				});
			});
		},
		//推荐人注册
		referralRegister: function referralRegister() {
			var _this3 = this;

			if (this.phone == '') {
				this.$message({
					message: "请填写手机号！",
					type: 'error',
					center: true,
					duration: 2000
				});
				return;
			}
			if (this.phone.length != 11) {
				this.$message({
					showClose: true,
					message: "手机格式有误，请重新输入！",
					type: 'error',
					center: true,
					duration: 2000
				});
				return;
			}
			if (this.code == '') {
				this.$message({
					message: "验证码不能为空",
					type: 'error',
					center: true,
					duration: 2000
				});
				return;
			}
			if (this.password == '') {
				this.$message({
					message: "请输入密码",
					type: 'error',
					center: true,
					duration: 2000
				});
				return;
			}
			if (this.passwords == '') {
				this.$message({
					message: "请重复密码",
					type: 'error',
					center: true,
					duration: 2000
				});
				return;
			}
			if (this.password != this.passwords) {
				this.$message({
					message: "两次密码不相同，请重新输入",
					type: 'error',
					center: true,
					duration: 2000
				});
				return;
			}
			var data = {
				phone: this.phone,
				code: this.code,
				password: this.password,
				regType: '0'
			};
			if (this.click != true) {
				this.$message({
					message: '请不要重复点击',
					type: 'error',
					center: true,
					duration: 1000
				});
				return;
			}
			this.click = false;
			this.$http.post({"system":"http://dl.itaojin.cn/reginalAgencyApi","systemHeader":"http://dl.itaojin.cn","statistics":"http://dl.itaojin.cn/tjkInfo","tjuser":"http://t.itaojin.cn/tjuser","provider":"http://dl.itaojin.cn/provider","RTY":"http://t.itaojin.cn/teamTalk/action"}.tjuser + '/register/aliYunRegister', data).then(function (response) {
				var result = response.data;
				if (result.success) {
					_this3.$message({
						message: '注册成功',
						type: 'success',
						center: true,
						duration: 1000
					});
					var self = _this3;
					setTimeout(function () {
						self.$router.push({ name: 'download' });
					}, 1500);
				} else {
					_this3.click = true;
					_this3.$message({
						message: result.msg,
						type: 'error',
						center: true,
						duration: 1000
					});
				}
			}, function (response) {
				_this3.click = true;
				_this3.$message({
					message: '网络繁忙，请稍后重试！',
					type: 'error',
					center: true,
					duration: 1000
				});
			});
		}
	}
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'download',
	data: function data() {
		return {
			opt_label: this.$route.query.fr ? this.$route.query.fr : 'itaojin'
		};
	},
	mounted: function mounted() {
		var hm = document.createElement("script");
		hm.src = "https://hm.baidu.com/hm.js?c2c18f245d6de5e40057411877b2018e";
		var s = document.getElementsByTagName("script")[0];
		s.parentNode.insertBefore(hm, s);
	},

	methods: {
		trackEvent: function trackEvent(e) {
			var a = e.target;
			a = $(a);
			window._hmt && window._hmt.push(['_trackEvent', 'APP下载推广', 'download', this.opt_label]);
			setTimeout(function () {
				window.location = 'http://t.itaojin.cn/pages/app_distribute.html';
			}, 100);
		}
	}
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'login',
  data: function data() {
    return {
      'account': '',
      'password': ''
    };
  },
  mounted: function mounted() {
    this.getCookie();
  },

  methods: {
    login: function login() {
      var _this = this;

      if (this.account == '') {
        this.$message({
          message: '请输入账号',
          type: 'error',
          center: true,
          duration: 2000
        });
        return;
      }
      if (this.password == '') {
        this.$message({
          message: '请输入密码',
          type: 'error',
          center: true,
          duration: 2000
        });
        return;
      }
      var data = {
        'phoneNumber': this.account,
        'password': this.password
      };
      this.$http.post({"system":"http://dl.itaojin.cn/reginalAgencyApi","systemHeader":"http://dl.itaojin.cn","statistics":"http://dl.itaojin.cn/tjkInfo","tjuser":"http://t.itaojin.cn/tjuser","provider":"http://dl.itaojin.cn/provider","RTY":"http://t.itaojin.cn/teamTalk/action"}.system + "/agency/login", data).then(function (response) {
        var result = response.data;
        if (result.success) {
          var self = _this;
          _this.$message({
            message: "登录成功",
            type: 'success',
            center: true,
            duration: 1000
          });
          _this.setCookie(_this.account, _this.password, 7);
          var exdate = new Date();
          exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * 7); //保存的天数
          window.document.cookie = "reginal_agency_token" + "=" + result.data.reginal_agency_token + ";path=/;expires=" + exdate.toGMTString();
          setTimeout(function () {
            self.$router.push({ name: 'runnability' });
          }, 1000);
        } else {
          _this.$message({
            message: result.msg,
            type: 'error',
            center: true,
            duration: 2000
          });
        }
      }, function (response) {
        _this.$message({
          message: '网络繁忙，请稍后重试！',
          type: 'error',
          center: true,
          duration: 2000
        });
      });
    },
    setCookie: function setCookie(c_name, c_pwd, exdays) {
      var exdate = new Date();
      exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); //保存的天数
      //字符串拼接cookie
      window.document.cookie = "userName" + "=" + c_name + ";path=/;expires=" + exdate.toGMTString();
      window.document.cookie = "userPwd" + "=" + c_pwd + ";path=/;expires=" + exdate.toGMTString();
    },

    getCookie: function getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; '); //这里显示的格式需要切割一下自己可输出看下
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('='); //再次切割
          //判断查找相对应的值
          if (arr2[0] == 'userName') {
            this.account = arr2[1]; //保存到保存数据的地方
          } else if (arr2[0] == 'userPwd') {
            this.password = arr2[1];
          }
        }
      }
    }
  }
});

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_header__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_header__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'myService',
  data: function data() {
    return {
      'addActive': 2,
      'pages': 1,
      'pageNum': 1,
      'pageSize': 10,
      'tjkTaskApplyState': '',
      'taskOptions': [{
        label: '全部',
        value: ''
      }, {
        label: '待培训',
        value: 'WaitTrained'
      }, {
        label: '培训',
        value: 'Training'
      }, {
        label: '待上岗',
        value: 'ForPost'
      }, {
        label: '上岗',
        value: 'InPost'
      }],
      'tjkUserId': '',
      'tjkName': '',
      'serviceList': [],
      'agentId': this.$route.query.agentId,
      'timer': ''
    };
  },

  watch: {
    tjkName: function tjkName() {
      if (this.tjkName == '') {
        this.tjkUserId = '';
      }
    }
  },
  mounted: function mounted() {
    this.searchOwnedTjk(1);
  },

  components: {
    Vueheader: __WEBPACK_IMPORTED_MODULE_1__components_header___default.a
  },
  methods: {
    //查询代理下的淘金客
    searchOwnedTjk: function searchOwnedTjk(num) {
      var _this = this;

      var data = {
        tjkId: this.tjkUserId,
        tjkStatus: this.tjkTaskApplyState,
        page: num ? num : this.pageNum,
        pageSize: this.pageSize,
        agentId: this.agentId
      };
      this.$http.post({"system":"http://dl.itaojin.cn/reginalAgencyApi","systemHeader":"http://dl.itaojin.cn","statistics":"http://dl.itaojin.cn/tjkInfo","tjuser":"http://t.itaojin.cn/tjuser","provider":"http://dl.itaojin.cn/provider","RTY":"http://t.itaojin.cn/teamTalk/action"}.system + '/agency/searchOwnedTjk', data).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this.serviceList = result.data.list;
          _this.pages = result.data.pages;
          _this.pageNum = result.data.pageNum;
        } else {
          _this.$message({
            message: result.msg,
            type: 'error',
            center: true,
            duration: 2000
          });
        }
      }, function (response) {
        _this.$message({
          message: '网络繁忙，请稍后重试！',
          type: 'error',
          center: true,
          duration: 2000
        });
      });
    },

    //修改代理下的淘金客
    updateTjkStatus: function updateTjkStatus(tjkId, tjkStatus) {
      var _this2 = this;

      var data = {
        tjkId: tjkId,
        tjkStatus: tjkStatus,
        agentId: this.agentId
      };
      this.$http.post({"system":"http://dl.itaojin.cn/reginalAgencyApi","systemHeader":"http://dl.itaojin.cn","statistics":"http://dl.itaojin.cn/tjkInfo","tjuser":"http://t.itaojin.cn/tjuser","provider":"http://dl.itaojin.cn/provider","RTY":"http://t.itaojin.cn/teamTalk/action"}.system + '/agency/updateTjkStatus', data).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this2.$message({
            message: '修改成功',
            type: 'success',
            center: true,
            duration: 1000
          });
          _this2.searchOwnedTjk(1);
        } else {
          _this2.$message({
            message: result.msg,
            type: 'error',
            center: true,
            duration: 2000
          });
        }
      }, function (response) {
        _this2.$message({
          message: '网络繁忙，请稍后重试！',
          type: 'error',
          center: true,
          duration: 2000
        });
      });
    },

    //查询淘金客用户
    tjkSearch: function tjkSearch(queryString, callback) {
      if (queryString !== '' && queryString.length >= 2) {
        clearTimeout(this.timer);
        var self = this;
        this.timer = setTimeout(function () {
          var tjkList = [];
          var data = {
            phoneNumber: queryString,
            page: 1,
            pageSize: self.pageSize
          };
          self.$http.post({"system":"http://dl.itaojin.cn/reginalAgencyApi","systemHeader":"http://dl.itaojin.cn","statistics":"http://dl.itaojin.cn/tjkInfo","tjuser":"http://t.itaojin.cn/tjuser","provider":"http://dl.itaojin.cn/provider","RTY":"http://t.itaojin.cn/teamTalk/action"}.system + '/agency/ownedTjkInfo', data).then(function (response) {
            var result = response.data;
            if (result.success) {
              self.success = result.success;
              self.message = result.msg;
              //在这里为这个数组中每一个对象加一个value字段, 因为autocomplete只识别value字段并在下拉列中显示  
              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(result.data.list), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var i = _step.value;

                  i.value = i.realName + '(' + i.loginName + ')';
                }
              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }

              tjkList = result.data.list;
              callback(tjkList);
            } else {
              self.$message({
                message: result.msg,
                type: 'error',
                center: true,
                duration: 2000
              });
            }
          }, function (response) {
            self.$message({
              message: '网络繁忙，请稍后重试！',
              type: 'error',
              center: true,
              duration: 2000
            });
          });
        }, 400);
      } else {
        clearTimeout(this.timer);
      }
    },
    tjkHandleSelect: function tjkHandleSelect(item) {
      this.tjkUserId = item.id;
    }
  }
});

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_json_provinces_json__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_json_provinces_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__static_json_provinces_json__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'providerBankCard',
	data: function data() {
		return {
			providerCode: this.$route.query.providerCode,
			tjk_login_token: this.$route.query.token,
			phone: this.$route.query.phone,
			provinceList: [], //省份
			citysList: [], //地市
			bankList: [{
				id: 'CCB',
				name: '建设银行'
			}, {
				id: 'ABC',
				name: '农业银行'
			}, {
				id: 'ICBC',
				name: '工商银行'
			}, {
				id: 'CMB',
				name: '招商银行'
			}],
			id: '', //绑定id
			idCardName: '', //真实姓名
			idCardNumber: '', //身份证号
			cashAccount: '', //卡号
			bankId: '', //银行卡类型
			bankProvince: '', //银行所在省份
			bankCity: '', //银行所在市
			bankArea: '', //支行名称
			bankName: '', //银行名称
			bankStatus: null, //银行卡绑定状态
			hasReal: false, //是否实名认证
			imageUrlFront: '', //身份证正面地址
			imageUrlBack: '', //身份证反面地址
			uploadUrl: {"system":"http://dl.itaojin.cn/reginalAgencyApi","systemHeader":"http://dl.itaojin.cn","statistics":"http://dl.itaojin.cn/tjkInfo","tjuser":"http://t.itaojin.cn/tjuser","provider":"http://dl.itaojin.cn/provider","RTY":"http://t.itaojin.cn/teamTalk/action"}.tjuser + '/info/uploadIdCardPicture'
		};
	},
	mounted: function mounted() {
		this.provinceList = __WEBPACK_IMPORTED_MODULE_1__static_json_provinces_json___default.a.provinces;
		if (this.tjk_login_token) {
			this.queryTjkInfo();
			this.queryBankStatus();
		}
	},

	watch: {
		bankId: function bankId() {
			var _this = this;

			this.bankList.map(function (item) {
				if (_this.bankId == item.id) {
					_this.bankName = item.name;
				}
			});
		}
	},
	methods: {
		//查询实名认证信息
		queryTjkInfo: function queryTjkInfo() {
			var _this2 = this;

			this.$http.post({"system":"http://dl.itaojin.cn/reginalAgencyApi","systemHeader":"http://dl.itaojin.cn","statistics":"http://dl.itaojin.cn/tjkInfo","tjuser":"http://t.itaojin.cn/tjuser","provider":"http://dl.itaojin.cn/provider","RTY":"http://t.itaojin.cn/teamTalk/action"}.tjuser + '/info/getTjkInfo', { 'tjk_login_token': this.tjk_login_token }).then(function (response) {
				var result = response.data;
				if (result.success) {
					if (result.data.realNameAuth == 'Authenticated') {
						_this2.hasReal = true;
						_this2.idCardName = result.data.realName ? result.data.realName : '';
						_this2.idCardNumber = result.data.idCardNumber ? result.data.idCardNumber : '';
					} else {
						_this2.hasReal = false;
					}
				} else {
					_this2.$message({
						message: result.msg,
						type: 'error',
						center: true,
						duration: 3000
					});
				}
			}, function (response) {
				_this2.$message({
					message: '网络繁忙，请稍后重试！',
					type: 'error',
					center: true,
					duration: 3000
				});
			});
		},

		//查询银行卡绑定状态
		queryBankStatus: function queryBankStatus() {
			var _this3 = this;

			this.$http.post({"system":"http://dl.itaojin.cn/reginalAgencyApi","systemHeader":"http://dl.itaojin.cn","statistics":"http://dl.itaojin.cn/tjkInfo","tjuser":"http://t.itaojin.cn/tjuser","provider":"http://dl.itaojin.cn/provider","RTY":"http://t.itaojin.cn/teamTalk/action"}.tjuser + '/provider/getProviderCashInfo', { 'tjk_login_token': this.tjk_login_token }).then(function (response) {
				var result = response.data;
				if (result.success) {
					if (result.data.cashInfo != null) {
						_this3.id = result.data.cashInfo ? result.data.cashInfo.id : '';
						_this3.bankStatus = result.data.cashInfo.status;
						_this3.cashAccount = result.data.cashInfo.cashAccount;
						_this3.bankId = result.data.cashInfo.bankId;
						_this3.bankProvince = result.data.cashInfo.bankProvince;
						_this3.bankCity = result.data.cashInfo.bankCity;
						_this3.bankArea = result.data.cashInfo.bankArea;
					}
				} else {
					_this3.$message({
						message: result.msg,
						type: 'error',
						center: true,
						duration: 3000
					});
				}
			}, function (response) {
				_this3.$message({
					message: '网络繁忙，请稍后重试！',
					type: 'error',
					center: true,
					duration: 3000
				});
			});
		},

		//根据省份查询地市
		queryCitysFun: function queryCitysFun() {
			var _this4 = this;

			this.provinceList.map(function (item) {
				if (item.provinceName == _this4.bankProvince) {
					_this4.citysList = item.citys;
				}
			});
		},

		//确认绑定银行卡
		bindBankCard: function bindBankCard() {
			var _this5 = this;

			if (!this.hasReal) {
				if (this.idCardName == '' || this.idCardName == null) {
					this.$message({
						message: '请填写真实姓名',
						type: 'error',
						center: true,
						duration: 3000
					});
					return;
				}
				if (this.idCardNumber == '' || this.idCardNumber == null) {
					this.$message({
						message: '请输入身份证号码',
						type: 'error',
						center: true,
						duration: 3000
					});
					return;
				}
				if (this.imageUrlFront == '') {
					this.$message({
						message: '请上传身份证正面照片',
						type: 'error',
						center: true,
						duration: 3000
					});
					return;
				}
				if (this.imageUrlBack == '') {
					this.$message({
						message: '请上传身份证反面照片',
						type: 'error',
						center: true,
						duration: 3000
					});
					return;
				}
			}
			// if(this.cashAccount == '' || this.cashAccount == null) {
			// 	this.$message({
			// 		message: '请输入银行卡号',
			// 		type: 'error',
			// 		center: true,
			// 		duration: 3000
			// 	})
			// 	return
			// }
			// if(this.bankId == '' || this.bankId == null) {
			// 	this.$message({
			// 		message: '请选择开户银行',
			// 		type: 'error',
			// 		center: true,
			// 		duration: 3000
			// 	})
			// 	return
			// }
			// if(this.bankProvince == '' || this.bankProvince == null) {
			// 	this.$message({
			// 		message: '请选择省份',
			// 		type: 'error',
			// 		center: true,
			// 		duration: 3000
			// 	})
			// 	return
			// }
			// if(this.bankCity == '' || this.bankCity == null) {
			// 	this.$message({
			// 		message: '请选择地市',
			// 		type: 'error',
			// 		center: true,
			// 		duration: 3000
			// 	})
			// 	return
			// }
			// if(this.bankArea == '' || this.bankArea == null) {
			// 	this.$message({
			// 		message: '请输入支行名称',
			// 		type: 'error',
			// 		center: true,
			// 		duration: 3000
			// 	})
			// 	return
			// }				
			var data = {
				tjk_login_token: this.tjk_login_token,
				idCardName: this.idCardName,
				cashAccount: this.cashAccount,
				bankId: this.bankId,
				bankProvince: this.bankProvince,
				bankCity: this.bankCity,
				bankArea: this.bankArea,
				idCardNumber: this.idCardNumber,
				bankName: this.bankName
			};
			this.$confirm('请确认是否填写正确!银行卡信息一旦提交不允许修改！', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '检查一下',
				type: 'warning'
			}).then(function () {
				_this5.$http.post({"system":"http://dl.itaojin.cn/reginalAgencyApi","systemHeader":"http://dl.itaojin.cn","statistics":"http://dl.itaojin.cn/tjkInfo","tjuser":"http://t.itaojin.cn/tjuser","provider":"http://dl.itaojin.cn/provider","RTY":"http://t.itaojin.cn/teamTalk/action"}.tjuser + '/provider/providerRealNameAuthAndBindBank', data).then(function (response) {
					var result = response.data;
					if (result.success) {
						_this5.$message({
							message: '绑定成功',
							type: 'success',
							center: true,
							duration: 3000
						});
						window.location.href = '/reginalAgent/providerHasLogin?token=' + _this5.tjk_login_token + '&phone=' + _this5.phone + '&providerCode=' + _this5.providerCode;
					} else {
						_this5.$message({
							message: result.msg,
							type: 'error',
							center: true,
							duration: 3000
						});
					}
				}, function (response) {
					_this5.$message({
						message: '网络繁忙，请稍后重试！',
						type: 'error',
						center: true,
						duration: 3000
					});
				});
			}).catch(function () {});
		},

		//解除绑定银行卡
		deleteCard: function deleteCard() {
			var _this6 = this;

			var data = {
				'id': this.id,
				'cashAccount': this.cashAccount,
				'bankId': this.bankId,
				'tjk_login_token': this.tjk_login_token
			};
			this.$confirm('解除绑定会影响报酬正常发放，确认解除绑定？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(function () {
				_this6.$http.post({"system":"http://dl.itaojin.cn/reginalAgencyApi","systemHeader":"http://dl.itaojin.cn","statistics":"http://dl.itaojin.cn/tjkInfo","tjuser":"http://t.itaojin.cn/tjuser","provider":"http://dl.itaojin.cn/provider","RTY":"http://t.itaojin.cn/teamTalk/action"}.tjuser + '/provider/unBindBankCard', data).then(function (response) {
					var result = response.data;
					if (result.success) {
						_this6.$message({
							message: '解除绑定成功',
							type: 'success',
							center: true,
							duration: 3000
						});
						setTimeout(function () {
							window.location.reload();
						}, 1000);
					} else {
						_this6.$message({
							message: result.msg,
							type: 'error',
							center: true,
							duration: 3000
						});
					}
				}, function (response) {
					_this6.$message({
						message: '网络繁忙，请稍后重试！',
						type: 'error',
						center: true,
						duration: 3000
					});
				});
			}).catch(function () {});
		},

		//上传身份证正面
		uploadFront: function uploadFront(item) {
			var self = this;
			var formData = new FormData();
			formData.append('idCardPicture', item.file);
			formData.append('idCardPictureType', 'IdCardPictureFront');
			formData.append('tjk_login_token', this.tjk_login_token);
			var config = {
				headers: {
					'Content-Type': 'multipart/form-data;'
				}
			};
			var ajax = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({});
			ajax.post({"system":"http://dl.itaojin.cn/reginalAgencyApi","systemHeader":"http://dl.itaojin.cn","statistics":"http://dl.itaojin.cn/tjkInfo","tjuser":"http://t.itaojin.cn/tjuser","provider":"http://dl.itaojin.cn/provider","RTY":"http://t.itaojin.cn/teamTalk/action"}.tjuser + "/info/uploadIdCardPicture", formData, config).then(function (response) {
				var result = response.data;
				if (result.success) {
					self.imageUrlFront = URL.createObjectURL(item.file);
				} else {
					self.$alert(result.msg);
				}
			}, function (response) {
				self.$alert("网络繁忙，请稍后重试！");
			});
		},

		//上传身份证反面
		uploadBack: function uploadBack(item) {
			var self = this;
			var formData = new FormData();
			formData.append('idCardPicture', item.file);
			formData.append('idCardPictureType', 'IdCardPictureBack');
			formData.append('tjk_login_token', this.tjk_login_token);
			var config = {
				headers: {
					'Content-Type': 'multipart/form-data;'
				}
			};
			var ajax = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({});
			ajax.post({"system":"http://dl.itaojin.cn/reginalAgencyApi","systemHeader":"http://dl.itaojin.cn","statistics":"http://dl.itaojin.cn/tjkInfo","tjuser":"http://t.itaojin.cn/tjuser","provider":"http://dl.itaojin.cn/provider","RTY":"http://t.itaojin.cn/teamTalk/action"}.tjuser + "/info/uploadIdCardPicture", formData, config).then(function (response) {
				var result = response.data;
				if (result.success) {
					self.imageUrlBack = URL.createObjectURL(item.file);
				} else {
					self.$alert(result.msg);
				}
			}, function (response) {
				self.$alert("网络繁忙，请稍后重试！");
			});
		}
	}
});

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'providerHasLogin',
	data: function data() {
		return {
			providerCode: this.$route.query.providerCode,
			tjk_login_token: this.$route.query.token,
			phone: this.$route.query.phone,
			password: '',
			bankStatus: null,
			content: ''
		};
	},
	mounted: function mounted() {
		this.queryBankStatus();
	},

	methods: {
		//查询银行卡绑定状态
		queryBankStatus: function queryBankStatus() {
			var _this = this;

			this.$http.post({"system":"http://dl.itaojin.cn/reginalAgencyApi","systemHeader":"http://dl.itaojin.cn","statistics":"http://dl.itaojin.cn/tjkInfo","tjuser":"http://t.itaojin.cn/tjuser","provider":"http://dl.itaojin.cn/provider","RTY":"http://t.itaojin.cn/teamTalk/action"}.tjuser + '/provider/getProviderCashInfo', { 'tjk_login_token': this.tjk_login_token }).then(function (response) {
				var result = response.data;
				if (result.success) {
					_this.bankStatus = !result.data.cashInfo ? null : result.data.cashInfo.status;
					_this.content = !result.data.content ? null : result.data.content;
				} else {
					_this.$message({
						message: result.msg,
						type: 'error',
						center: true,
						duration: 3000
					});
				}
			}, function (response) {
				_this.$message({
					message: '网络繁忙，请稍后重试！',
					type: 'error',
					center: true,
					duration: 3000
				});
			});
		},

		//修改信息
		changeFun: function changeFun() {
			var _this2 = this;

			if (this.password == '') {
				this.$message({
					message: '请输入密码',
					type: 'error',
					center: true,
					duration: 3000
				});
				return;
			}
			var data = {
				tjk_login_token: this.tjk_login_token,
				password: this.password
			};
			this.$http.post({"system":"http://dl.itaojin.cn/reginalAgencyApi","systemHeader":"http://dl.itaojin.cn","statistics":"http://dl.itaojin.cn/tjkInfo","tjuser":"http://t.itaojin.cn/tjuser","provider":"http://dl.itaojin.cn/provider","RTY":"http://t.itaojin.cn/teamTalk/action"}.tjuser + '/provider/updateProviderInfo', data).then(function (response) {
				var result = response.data;
				if (result.success) {
					_this2.$message({
						message: '修改成功',
						type: 'success',
						center: true,
						duration: 3000
					});
				} else {
					_this2.$message({
						message: result.msg,
						type: 'error',
						center: true,
						duration: 3000
					});
				}
			}, function (response) {
				_this2.$message({
					message: '网络繁忙，请稍后重试！',
					type: 'error',
					center: true,
					duration: 3000
				});
			});
		}
	}
});

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'providerLogin',
	data: function data() {
		return {
			providerCode: this.$route.query.providerCode,
			loginName: '',
			loginPwd: '',
			tjk_login_token: ''
		};
	},
	mounted: function mounted() {},

	methods: {
		//合伙人登录
		providerLogin: function providerLogin() {
			var _this = this;

			if (this.loginName == '') {
				this.$message({
					message: '请填写手机号码',
					type: 'error',
					center: true,
					duration: 3000
				});
				return;
			}
			if (this.loginPwd == '') {
				this.$message({
					message: '请输入密码',
					type: 'error',
					center: true,
					duration: 3000
				});
				return;
			}
			var data = {
				teamCode: '000',
				loginName: this.loginName,
				loginPwd: this.loginPwd,
				deviceType: 'PC'
			};
			this.$http.post({"system":"http://dl.itaojin.cn/reginalAgencyApi","systemHeader":"http://dl.itaojin.cn","statistics":"http://dl.itaojin.cn/tjkInfo","tjuser":"http://t.itaojin.cn/tjuser","provider":"http://dl.itaojin.cn/provider","RTY":"http://t.itaojin.cn/teamTalk/action"}.tjuser + '/tjkLogin/provider/login', data).then(function (response) {
				var result = response.data;
				if (result.success) {
					_this.tjk_login_token = result.data;
					window.location.href = '/reginalAgent/providerHasLogin?token=' + _this.tjk_login_token + '&phone=' + _this.loginName + '&providerCode=' + _this.providerCode;
				} else {
					_this.$message({
						message: result.msg,
						type: 'error',
						center: true,
						duration: 3000
					});
				}
			}, function (response) {
				_this.$message({
					message: '网络繁忙，请稍后重试！',
					type: 'error',
					center: true,
					duration: 3000
				});
			});
		}
	}
});

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'providerRegister',
	data: function data() {
		return {
			tjk_login_token: null, //注册成功后返回token
			form: {
				phone: '',
				password: ''
			},
			providerCode: this.$route.query.providerCode //'D85688FCE613669775C5EEF50F20386A'
		};
	},
	mounted: function mounted() {
		if (this.providerCode) {
			this.checkCode();
		}
	},

	methods: {
		//判断合作公司推荐注册二维码
		checkCode: function checkCode() {
			var _this = this;

			var data = {
				'providerCode': this.providerCode ? this.providerCode : ''
			};
			this.$http.post({"system":"http://dl.itaojin.cn/reginalAgencyApi","systemHeader":"http://dl.itaojin.cn","statistics":"http://dl.itaojin.cn/tjkInfo","tjuser":"http://t.itaojin.cn/tjuser","provider":"http://dl.itaojin.cn/provider","RTY":"http://t.itaojin.cn/teamTalk/action"}.provider + '/agent/checkCode', data).then(function (response) {
				var result = response.data;
				if (result.success) {} else {
					_this.$message({
						message: result.msg,
						type: 'error',
						center: true,
						duration: 2000
					});
				}
			}, function (response) {
				_this.$message({
					showClose: true,
					message: '网络繁忙，请稍后重试！',
					type: 'error',
					center: true,
					duration: 2000
				});
			});
		},

		//合作公司推荐人注册
		providerRegister: function providerRegister() {
			var _this2 = this;

			var self = this;
			if (this.form.phone == '') {
				this.$message({
					message: '请填写手机号码',
					type: 'error',
					center: true,
					duration: 3000
				});
				return;
			}
			if (this.form.phone.length != 11) {
				this.$message({
					message: '手机格式有误，请重新输入！',
					type: 'error',
					center: true,
					duration: 3000
				});
				return;
			}
			if (this.form.password == '') {
				this.$message({
					message: '请输入密码',
					type: 'error',
					center: true,
					duration: 3000
				});
				return;
			}
			var data = {
				phone: this.form.phone,
				password: this.form.password,
				providerCode: this.providerCode
			};
			this.$http.post({"system":"http://dl.itaojin.cn/reginalAgencyApi","systemHeader":"http://dl.itaojin.cn","statistics":"http://dl.itaojin.cn/tjkInfo","tjuser":"http://t.itaojin.cn/tjuser","provider":"http://dl.itaojin.cn/provider","RTY":"http://t.itaojin.cn/teamTalk/action"}.tjuser + '/provider/providerRegister', data).then(function (response) {
				var result = response.data;
				if (result.success) {
					_this2.tjk_login_token = result.data;
					window.location.href = '/reginalAgent/providerHasLogin?token=' + _this2.tjk_login_token + '&phone=' + _this2.form.phone + '&providerCode=' + _this2.providerCode;
				} else {
					_this2.$message({
						message: result.msg,
						type: 'error',
						center: true,
						duration: 3000
					});
				}
			}, function (response) {
				_this2.$message({
					message: '网络繁忙，请稍后重试！',
					type: 'error',
					center: true,
					duration: 3000
				});
			});
		}
	}
});

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'register',
	data: function data() {
		return {
			'phone': '',
			'code': '',
			'password': '',
			'passwords': '',
			'timer': '',
			'recommendToken': this.$route.query.reginal_agency_token,
			'recommendCode': this.$route.query.rcmd_code,
			'click': true,
			'codeClick': true
		};
	},
	mounted: function mounted() {
		if (this.recommendToken) {
			this.checkAgentToken();
		} else if (this.recommendCode) {
			this.checkRcmdCode();
		}
	},

	watch: {},
	methods: {
		//判断区域代理二维码
		checkAgentToken: function checkAgentToken() {
			var _this = this;

			var data = {
				'recommendToken': this.recommendToken ? this.recommendToken : ''
			};
			this.$http.post({"system":"http://dl.itaojin.cn/reginalAgencyApi","systemHeader":"http://dl.itaojin.cn","statistics":"http://dl.itaojin.cn/tjkInfo","tjuser":"http://t.itaojin.cn/tjuser","provider":"http://dl.itaojin.cn/provider","RTY":"http://t.itaojin.cn/teamTalk/action"}.system + '/agency/checkAgentToken', data).then(function (response) {
				var result = response.data;
				if (result.success) {} else {
					_this.$message({
						message: "推荐信息不正确，请退出",
						type: 'error',
						center: true,
						duration: 2000
					});
				}
			}, function (response) {
				_this.$message({
					showClose: true,
					message: "网络繁忙，请稍后重试！",
					type: 'error',
					center: true,
					duration: 2000
				});
			});
		},
		//判断推荐人奖励二维码
		checkRcmdCode: function checkRcmdCode() {
			var _this2 = this;

			var data = {
				'rcmdCode': this.recommendCode ? this.recommendCode : ''
			};
			this.$http.post({"system":"http://dl.itaojin.cn/reginalAgencyApi","systemHeader":"http://dl.itaojin.cn","statistics":"http://dl.itaojin.cn/tjkInfo","tjuser":"http://t.itaojin.cn/tjuser","provider":"http://dl.itaojin.cn/provider","RTY":"http://t.itaojin.cn/teamTalk/action"}.statistics + '/recommender/checkRcmdCode', data).then(function (response) {
				var result = response.data;
				if (result.success) {} else {
					_this2.$message({
						message: "推荐信息不正确，请退出",
						type: 'error',
						center: true,
						duration: 2000
					});
				}
			}, function (response) {
				_this2.$message({
					showClose: true,
					message: "网络繁忙，请稍后重试！",
					type: 'error',
					center: true,
					duration: 2000
				});
			});
		},
		//验证码计时
		gainCode: function gainCode() {
			var txt = $('.code').text();
			if (txt == '获取' || txt == '重发') {
				clearInterval(this.timer);
				$('.code').text('60');
				var self = this;
				this.timer = setInterval(function () {
					var text = $('.code').text();
					if (text == 1) {
						$('.code').text('重发');
						self.codeClick = true;
						clearInterval(self.timer);
						return;
					} else {
						text--;
						self.codeClick = false;
						$('.code').text(text);
					}
				}, 1000);
			} else {
				return;
			}
		},
		//获取加密数据
		getSignature: function getSignature(recommend) {
			var _this3 = this;

			if (!this.codeClick) {
				return;
			}
			if (this.phone == '') {
				this.$message({
					message: "请填写手机号！",
					type: 'error',
					center: true,
					duration: 2000
				});
				return;
			} else if (this.phone.length != 11) {
				this.$message({
					message: "手机格式有误，请重新输入！",
					type: 'error',
					center: true,
					duration: 2000
				});
				return;
			}
			if (recommend == '' || recommend == undefined || recommend == null) {
				this.$message({
					message: "推荐码不存在，请退出",
					type: 'error',
					center: true,
					duration: 2000
				});
				return;
			}
			var data = {
				'phone': this.phone,
				'invitationCode': recommend
			};
			this.$http.post({"system":"http://dl.itaojin.cn/reginalAgencyApi","systemHeader":"http://dl.itaojin.cn","statistics":"http://dl.itaojin.cn/tjkInfo","tjuser":"http://t.itaojin.cn/tjuser","provider":"http://dl.itaojin.cn/provider","RTY":"http://t.itaojin.cn/teamTalk/action"}.tjuser + '/register/getSignature', data).then(function (response) {
				var result = response.data;
				if (result.success) {
					_this3.sendSms(result.data);
				} else {
					_this3.$message({
						message: result.msg,
						type: 'error',
						center: true,
						duration: 2000
					});
				}
			}, function (response) {
				_this3.$message({
					message: "网络繁忙，请稍后重试！",
					type: 'error',
					center: true,
					duration: 2000
				});
			});
		},
		//获取短信
		sendSms: function sendSms(sig) {
			var _this4 = this;

			var data = {
				signature: sig,
				phoneNumber: this.phone
			};
			this.$http.post({"system":"http://dl.itaojin.cn/reginalAgencyApi","systemHeader":"http://dl.itaojin.cn","statistics":"http://dl.itaojin.cn/tjkInfo","tjuser":"http://t.itaojin.cn/tjuser","provider":"http://dl.itaojin.cn/provider","RTY":"http://t.itaojin.cn/teamTalk/action"}.tjuser + "/register/sendSms", data).then(function (response) {
				var result = response.data;
				if (result.success) {
					_this4.$message({
						message: '发送成功',
						type: 'success',
						center: true,
						duration: 2000
					});
					_this4.gainCode();
				} else {
					_this4.$message({
						message: result.msg,
						type: 'error',
						center: true,
						duration: 2000
					});
					if (result.msg == '当前手机号已经注册') {
						clearInterval(_this4.timer);
						$('.code').text('重发');
					}
				}
			}, function (response) {
				_this4.$message({
					message: "网络繁忙，请稍后重试！",
					type: 'error',
					center: true,
					duration: 2000
				});
			});
		},
		//区域代理注册
		register: function register() {
			var _this5 = this;

			if (this.phone == '') {
				this.$message({
					message: "请填写手机号！",
					type: 'error',
					center: true,
					duration: 2000
				});
				return;
			}
			if (this.phone.length != 11) {
				this.$message({
					showClose: true,
					message: "手机格式有误，请重新输入！",
					type: 'error',
					center: true,
					duration: 2000
				});
				return;
			}
			if (this.code == '') {
				this.$message({
					message: "验证码不能为空",
					type: 'error',
					center: true,
					duration: 2000
				});
				return;
			}
			if (this.password == '') {
				this.$message({
					message: "请输入密码",
					type: 'error',
					center: true,
					duration: 2000
				});
				return;
			}
			if (this.passwords == '') {
				this.$message({
					message: "请重复密码",
					type: 'error',
					center: true,
					duration: 2000
				});
				return;
			}
			if (this.password != this.passwords) {
				this.$message({
					message: "两次密码不相同，请重新输入",
					type: 'error',
					center: true,
					duration: 2000
				});
				return;
			}
			var data = {
				phone: this.phone,
				code: this.code,
				password: this.password,
				regType: '0',
				invitationCode: this.recommendToken,
				registerChannel: 'RECOMMEND_REGISTER'
			};
			if (this.click != true) {
				this.$message({
					message: '请不要重复点击',
					type: 'error',
					center: true,
					duration: 1000
				});
				return;
			}
			this.click = false;
			this.$http.post({"system":"http://dl.itaojin.cn/reginalAgencyApi","systemHeader":"http://dl.itaojin.cn","statistics":"http://dl.itaojin.cn/tjkInfo","tjuser":"http://t.itaojin.cn/tjuser","provider":"http://dl.itaojin.cn/provider","RTY":"http://t.itaojin.cn/teamTalk/action"}.tjuser + '/register/regionalAgencyCreateTjkUser', data).then(function (response) {
				var result = response.data;
				if (result.success) {
					_this5.$message({
						message: '注册成功',
						type: 'success',
						center: true,
						duration: 1000
					});
					var self = _this5;
					setTimeout(function () {
						self.$router.push({ name: 'download' });
					}, 1500);
				} else {
					_this5.click = true;
					_this5.$message({
						message: result.msg,
						type: 'error',
						center: true,
						duration: 1000
					});
				}
			}, function (response) {
				_this5.click = true;
				_this5.$message({
					message: '网络繁忙，请稍后重试！',
					type: 'error',
					center: true,
					duration: 1000
				});
			});
		},
		//推荐人注册
		referralRegister: function referralRegister() {
			var _this6 = this;

			if (this.phone == '') {
				this.$message({
					message: "请填写手机号！",
					type: 'error',
					center: true,
					duration: 2000
				});
				return;
			}
			if (this.phone.length != 11) {
				this.$message({
					showClose: true,
					message: "手机格式有误，请重新输入！",
					type: 'error',
					center: true,
					duration: 2000
				});
				return;
			}
			if (this.code == '') {
				this.$message({
					message: "验证码不能为空",
					type: 'error',
					center: true,
					duration: 2000
				});
				return;
			}
			if (this.password == '') {
				this.$message({
					message: "请输入密码",
					type: 'error',
					center: true,
					duration: 2000
				});
				return;
			}
			if (this.passwords == '') {
				this.$message({
					message: "请重复密码",
					type: 'error',
					center: true,
					duration: 2000
				});
				return;
			}
			if (this.password != this.passwords) {
				this.$message({
					message: "两次密码不相同，请重新输入",
					type: 'error',
					center: true,
					duration: 2000
				});
				return;
			}
			var data = {
				phone: this.phone,
				code: this.code,
				password: this.password,
				regType: '0',
				recommendCode: this.recommendCode,
				registerChannel: 'RECOMMEND_REGISTER'
			};
			if (this.click != true) {
				this.$message({
					message: '请不要重复点击',
					type: 'error',
					center: true,
					duration: 1000
				});
				return;
			}
			this.click = false;
			this.$http.post({"system":"http://dl.itaojin.cn/reginalAgencyApi","systemHeader":"http://dl.itaojin.cn","statistics":"http://dl.itaojin.cn/tjkInfo","tjuser":"http://t.itaojin.cn/tjuser","provider":"http://dl.itaojin.cn/provider","RTY":"http://t.itaojin.cn/teamTalk/action"}.tjuser + '/register/recommendCreateTjkUser', data).then(function (response) {
				var result = response.data;
				if (result.success) {
					_this6.$message({
						message: '注册成功',
						type: 'success',
						center: true,
						duration: 1000
					});
					var self = _this6;
					setTimeout(function () {
						self.$router.push({ name: 'download' });
					}, 1500);
				} else {
					_this6.click = true;
					_this6.$message({
						message: result.msg,
						type: 'error',
						center: true,
						duration: 1000
					});
				}
			}, function (response) {
				_this6.click = true;
				_this6.$message({
					message: '网络繁忙，请稍后重试！',
					type: 'error',
					center: true,
					duration: 1000
				});
			});
		}
	}
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_highcharts__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_highcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue2_highcharts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_header__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_header__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'runnability',
  data: function data() {
    return {
      'addActive': 1,
      'xAxis': '日期（年/月/日）',
      'yTitle': '数量（人）',
      'botTxt': '每日推荐人',
      'options': {},
      'agentId': this.$route.query.agentId,
      'yList': [],
      'xList': [],
      'referrer': '',
      'mount': '',
      'time': '',
      'icon': ''
    };
  },
  mounted: function mounted() {
    this.statistics();
    this.searchAgent();
    this.optionsObject();
  },

  components: {
    VueHighcharts: __WEBPACK_IMPORTED_MODULE_0_vue2_highcharts___default.a,
    Vueheader: __WEBPACK_IMPORTED_MODULE_1__components_header___default.a
  },
  methods: {
    statistics: function statistics(txt) {
      var _this = this;

      $('.ledger').removeClass('active');
      if (txt == 'mount') {
        $('.ledger').eq(1).addClass('active');
      } else if (txt == 'duration') {
        $('.ledger').eq(2).addClass('active');
      } else {
        $('.ledger').eq(0).addClass('active');
      }
      var data = {
        'agentId': this.agentId
      };
      this.$http.post({"system":"http://dl.itaojin.cn/reginalAgencyApi","systemHeader":"http://dl.itaojin.cn","statistics":"http://dl.itaojin.cn/tjkInfo","tjuser":"http://t.itaojin.cn/tjuser","provider":"http://dl.itaojin.cn/provider","RTY":"http://t.itaojin.cn/teamTalk/action"}.system + "/agency/statistics", data).then(function (response) {
        var result = response.data;
        _this.yList = [];
        _this.xList = [];
        _this.referrer = '';
        _this.mount = '';
        _this.time = '';
        if (result.success) {
          var obj = {};
          var data = result.data.list;
          for (var i = 0; i < data.length; i++) {
            _this.xList.push(data[i].createDay);
            _this.referrer = _this.referrer + data[i].recommenders;
            _this.mount = _this.mount + data[i].onJobs;
            _this.time = _this.time + data[i].workHour;
          }
          _this.judge(txt, data);
          _this.load();
          _this.optionsObject();
        } else {
          _this.$message({
            message: result.msg,
            type: 'error',
            center: true,
            duration: 2000
          });
        }
      }, function (response) {
        _this.$message({
          message: '网络繁忙，请稍后重试！',
          type: 'error',
          center: true,
          duration: 2000
        });
      });
    },
    //查询代理人
    searchAgent: function searchAgent() {
      var _this2 = this;

      var data = {
        page: 1,
        pageSize: 1
      };
      this.$http.post({"system":"http://dl.itaojin.cn/reginalAgencyApi","systemHeader":"http://dl.itaojin.cn","statistics":"http://dl.itaojin.cn/tjkInfo","tjuser":"http://t.itaojin.cn/tjuser","provider":"http://dl.itaojin.cn/provider","RTY":"http://t.itaojin.cn/teamTalk/action"}.system + "/agency/search", data).then(function (response) {
        var result = response.data;
        if (result.success) {
          _this2.icon = result.data.list[0].recommendLink;
        } else {
          _this2.$message({
            message: result.msg,
            type: 'error',
            center: true,
            duration: 2000
          });
        }
      }, function (response) {
        _this2.$message({
          message: '网络繁忙，请稍后重试！',
          type: 'error',
          center: true,
          duration: 2000
        });
      });
    },

    //变化曲线图信息
    judge: function judge(txt, data) {
      if (txt == 'mount') {
        this.yTitle = "数量（人）";
        this.botTxt = '每日总上岗人';
        for (var i = 0; i < data.length; i++) {
          this.yList.push(data[i].onJobs);
        }
      } else if (txt == 'duration') {
        this.yTitle = "时间（H）";
        this.botTxt = '每日总服务时长';
        for (var i = 0; i < data.length; i++) {
          this.yList.push(data[i].workHour);
        }
      } else {
        this.yTitle = "数量（人）";
        this.botTxt = '每日推荐人';
        for (var i = 0; i < data.length; i++) {
          this.yList.push(data[i].recommenders);
        }
      }
    },
    //渲染曲线图数据
    optionsObject: function optionsObject() {
      this.options = {
        asyncData: {
          name: this.botTxt,
          marker: {
            symbol: ''
          },
          data: this.yList
        },
        chart: {
          type: 'spline'
        },
        title: {
          text: ''
        },
        subtitle: {
          text: ''
        },
        xAxis: {
          title: {
            text: this.xAxis
          },
          categories: this.xList
        },
        yAxis: {
          title: {
            text: this.yTitle
          },
          min: 0,
          allowDecimals: false,
          labels: {
            formatter: function formatter() {
              return this.value;
            }
          }
        },
        tooltip: {
          crosshairs: true,
          shared: true
        },
        credits: {
          enabled: false
        },
        plotOptions: {
          spline: {
            marker: {
              radius: 4,
              lineColor: '#666666',
              lineWidth: 1
            }
          }
        },
        series: []
      };
    },
    //加载曲线图
    load: function load() {
      var _this3 = this;

      var lineCharts = this.$refs.lineCharts;
      lineCharts.delegateMethod('showLoading', 'Loading...');
      lineCharts.removeSeries(this.options.asyncData);
      setTimeout(function () {
        $(".highcharts-legend").remove();
        lineCharts.addSeries(_this3.options.asyncData);
        lineCharts.hideLoading();
      }, 0);
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'register',
	data: function data() {
		return {
			'phone': '',
			'code': '',
			'password': '',
			'passwords': '',
			'timer': '',
			'taskInfoCode': this.$route.query.taskInfoCode,
			'click': true,
			'codeClick': true,
			activityId: this.$route.query.activityId,
			shareCode: this.$route.query.shareCode,
			shareChannel: this.$route.query.shareChannel
		};
	},
	mounted: function mounted() {
		if (this.taskInfoCode) {
			this.checkRcmdCode();
		}
	},

	watch: {},
	methods: {
		//判断推荐人奖励二维码
		checkRcmdCode: function checkRcmdCode() {
			var _this = this;

			var data = {
				'rcmdCode': this.taskInfoCode ? this.taskInfoCode : ''
			};
			this.$http.post({"system":"http://dl.itaojin.cn/reginalAgencyApi","systemHeader":"http://dl.itaojin.cn","statistics":"http://dl.itaojin.cn/tjkInfo","tjuser":"http://t.itaojin.cn/tjuser","provider":"http://dl.itaojin.cn/provider","RTY":"http://t.itaojin.cn/teamTalk/action"}.statistics + '/recommender/checkRcmdCode', data).then(function (response) {
				var result = response.data;
				if (result.success) {} else {
					_this.$message({
						message: "推荐信息不正确，请退出",
						type: 'error',
						center: true,
						duration: 2000
					});
				}
			}, function (response) {
				_this.$message({
					showClose: true,
					message: "网络繁忙，请稍后重试！",
					type: 'error',
					center: true,
					duration: 2000
				});
			});
		},
		//验证码计时
		gainCode: function gainCode() {
			var txt = $('.code').text();
			if (txt == '获取' || txt == '重发') {
				clearInterval(this.timer);
				$('.code').text('60');
				var self = this;
				this.timer = setInterval(function () {
					var text = $('.code').text();
					if (text == 1) {
						$('.code').text('重发');
						self.codeClick = true;
						clearInterval(self.timer);
						return;
					} else {
						text--;
						self.codeClick = false;
						$('.code').text(text);
					}
				}, 1000);
			} else {
				return;
			}
		},
		//获取加密数据
		getSignature: function getSignature(recommend) {
			var _this2 = this;

			if (!this.codeClick) {
				return;
			}
			if (this.phone == '') {
				this.$message({
					message: "请填写手机号！",
					type: 'error',
					center: true,
					duration: 2000
				});
				return;
			} else if (this.phone.length != 11) {
				this.$message({
					message: "手机格式有误，请重新输入！",
					type: 'error',
					center: true,
					duration: 2000
				});
				return;
			}
			if (recommend == '' || recommend == undefined || recommend == null) {
				this.$message({
					message: "推荐码不存在，请退出",
					type: 'error',
					center: true,
					duration: 2000
				});
				return;
			}
			var data = {
				'phone': this.phone,
				'invitationCode': recommend
			};
			this.$http.post({"system":"http://dl.itaojin.cn/reginalAgencyApi","systemHeader":"http://dl.itaojin.cn","statistics":"http://dl.itaojin.cn/tjkInfo","tjuser":"http://t.itaojin.cn/tjuser","provider":"http://dl.itaojin.cn/provider","RTY":"http://t.itaojin.cn/teamTalk/action"}.tjuser + '/register/getSignature', data).then(function (response) {
				var result = response.data;
				if (result.success) {
					_this2.sendSms(result.data);
				} else {
					_this2.$message({
						message: result.msg,
						type: 'error',
						center: true,
						duration: 2000
					});
				}
			}, function (response) {
				_this2.$message({
					message: "网络繁忙，请稍后重试！",
					type: 'error',
					center: true,
					duration: 2000
				});
			});
		},
		//获取短信
		sendSms: function sendSms(sig) {
			var _this3 = this;

			var data = {
				signature: sig,
				phoneNumber: this.phone
			};
			this.$http.post({"system":"http://dl.itaojin.cn/reginalAgencyApi","systemHeader":"http://dl.itaojin.cn","statistics":"http://dl.itaojin.cn/tjkInfo","tjuser":"http://t.itaojin.cn/tjuser","provider":"http://dl.itaojin.cn/provider","RTY":"http://t.itaojin.cn/teamTalk/action"}.tjuser + "/register/sendSms", data).then(function (response) {
				var result = response.data;
				if (result.success) {
					_this3.$message({
						message: '发送成功',
						type: 'success',
						center: true,
						duration: 2000
					});
					_this3.gainCode();
				} else {
					_this3.$message({
						message: result.msg,
						type: 'error',
						center: true,
						duration: 2000
					});
					if (result.msg == '当前手机号已经注册') {
						clearInterval(_this3.timer);
						$('.code').text('重发');
					}
				}
			}, function (response) {
				_this3.$message({
					message: "网络繁忙，请稍后重试！",
					type: 'error',
					center: true,
					duration: 2000
				});
			});
		},
		//推荐人注册
		referralRegister: function referralRegister() {
			var _this4 = this;

			if (this.phone == '') {
				this.$message({
					message: "请填写手机号！",
					type: 'error',
					center: true,
					duration: 2000
				});
				return;
			}
			if (this.phone.length != 11) {
				this.$message({
					showClose: true,
					message: "手机格式有误，请重新输入！",
					type: 'error',
					center: true,
					duration: 2000
				});
				return;
			}
			if (this.code == '') {
				this.$message({
					message: "验证码不能为空",
					type: 'error',
					center: true,
					duration: 2000
				});
				return;
			}
			if (this.password == '') {
				this.$message({
					message: "请输入密码",
					type: 'error',
					center: true,
					duration: 2000
				});
				return;
			}
			if (this.passwords == '') {
				this.$message({
					message: "请重复密码",
					type: 'error',
					center: true,
					duration: 2000
				});
				return;
			}
			if (this.password != this.passwords) {
				this.$message({
					message: "两次密码不相同，请重新输入",
					type: 'error',
					center: true,
					duration: 2000
				});
				return;
			}
			var data = {
				phone: this.phone,
				code: this.code,
				password: this.password,
				regType: '0',
				recommendCode: this.taskInfoCode,
				registerChannel: 'SHARE_TASK_REGISTER',
				activityId: this.activityId,
				shareCode: this.shareCode,
				shareChannel: this.shareChannel
			};
			if (this.click != true) {
				this.$message({
					message: '请不要重复点击',
					type: 'error',
					center: true,
					duration: 1000
				});
				return;
			}
			this.click = false;
			this.$http.post({"system":"http://dl.itaojin.cn/reginalAgencyApi","systemHeader":"http://dl.itaojin.cn","statistics":"http://dl.itaojin.cn/tjkInfo","tjuser":"http://t.itaojin.cn/tjuser","provider":"http://dl.itaojin.cn/provider","RTY":"http://t.itaojin.cn/teamTalk/action"}.tjuser + '/register/recommendCreateTjkUser', data).then(function (response) {
				var result = response.data;
				if (result.success) {
					_this4.$message({
						message: '注册成功',
						type: 'success',
						center: true,
						duration: 1000
					});
					var self = _this4;
					setTimeout(function () {
						self.$router.push({ name: 'download' });
					}, 1500);
				} else {
					_this4.click = true;
					_this4.$message({
						message: result.msg,
						type: 'error',
						center: true,
						duration: 1000
					});
				}
			}, function (response) {
				_this4.click = true;
				_this4.$message({
					message: '网络繁忙，请稍后重试！',
					type: 'error',
					center: true,
					duration: 1000
				});
			});
		}
	}
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_qs__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_less_app_system_less__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_less_app_system_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_less_app_system_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_pagination__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_default_index_css__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_default_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_default_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_quill_editor__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_quill_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_quill_editor__);

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.















/******** 发送请求前配置请求及参数 ********/
__WEBPACK_IMPORTED_MODULE_4_axios___default.a.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
__WEBPACK_IMPORTED_MODULE_4_axios___default.a.interceptors.request.use(function (config) {
    if (config.method === 'post') {
        // 上传到七牛时如果在参数中添加login_token会报错
        if (config.url == 'http://upload.qiniu.com') return config;
        if (!config.data) config.data = {};
        config.data = __WEBPACK_IMPORTED_MODULE_5_qs___default.a.stringify(config.data, { allowDots: true });
    }
    return config;
}, function (error) {
    _.toast("错误的传参", 'fail');
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

__WEBPACK_IMPORTED_MODULE_4_axios___default.a.interceptors.response.use(function (res) {
    if (!res.data.success && res.data.data == 201) {
        //alert('会话失效，请重新登录')
        window.location.href = {"system":"http://dl.itaojin.cn/reginalAgencyApi","systemHeader":"http://dl.itaojin.cn","statistics":"http://dl.itaojin.cn/tjkInfo","tjuser":"http://t.itaojin.cn/tjuser","provider":"http://dl.itaojin.cn/provider","RTY":"http://t.itaojin.cn/teamTalk/action"}.systemHeader + '/reginalAgent/login';
    }
    return res;
}, function (error) {
    _.toast("网络异常", 'fail');
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$http = __WEBPACK_IMPORTED_MODULE_4_axios___default.a;
/******** 发送请求前配置请求及参数 END ********/

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;

// 注册分页组件
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_7__components_pagination___default.a.name, __WEBPACK_IMPORTED_MODULE_7__components_pagination___default.a);

// 注册ElementUI组件
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_element_ui___default.a);

// 注册富文本组件
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_vue_quill_editor___default.a);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a }
});

/***/ }),
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(50)(false);
// imports


// module
exports.push([module.i, "\n.quill-editor img {\n  max-width: 100%;\n}\n", ""]);

// exports


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(50)(false);
// imports


// module
exports.push([module.i, "\n.tips {\n\t\tfont-size: 0.85em;\n\t\tcolor: red !important;\n}\n.idcard {\n\t\tfloat: left;\n\t\twidth: 50%;\n    text-align: center;\n}\n.avatar-uploader .el-upload {\n    border: 1px dashed #d9d9d9;\n    border-radius: 6px;\n    cursor: pointer;\n    position: relative;\n    overflow: hidden;\n}\n.avatar-uploader .el-upload:hover {\n    border-color: #409EFF;\n}\n.avatar-uploader-icon {\n    font-size: 28px;\n    color: #8c939d;\n    width: 148px;\n    height: 148px;\n    line-height: 148px;\n    text-align: center;\n}\n.avatar {\n    width: 148px;\n    height: 148px;\n    display: block;\n}\n", ""]);

// exports


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(50)(false);
// imports


// module
exports.push([module.i, "\nheader[data-v-8eca63bc] {\n  height: 80px;\n  width: 100%;\n  background: #30313e;\n  overflow: hidden;\n}\nheader > .logo[data-v-8eca63bc] {\n  width: 60px;\n  height: 60px;\n  margin-left: 20px;\n  margin-top: 10px;\n  float: left;\n}\nheader > p[data-v-8eca63bc] {\n  height: 30px;\n  font-size: 20px;\n  color: #fff;\n  line-height: 20px;\n  margin-left: 10px;\n  margin-top: 30px;\n  float: left;\n}\nheader > ul[data-v-8eca63bc] {\n  margin-left: 200px;\n  height: 40px;\n  font-size: 18px;\n  margin-top: 25px;\n  float: left;\n  overflow: hidden;\n}\nheader > ul > li[data-v-8eca63bc] {\n  float: left;\n  color: #fff;\n  height: 40px;\n  width: 112px;\n  text-align: center;\n  line-height: 30px;\n  cursor: pointer;\n  position: relative;\n  margin-left: 5px;\n}\nheader > ul > li > a[data-v-8eca63bc] {\n  width: 100%;\n  height: 100%;\n  display: block;\n  color: #fff;\n}\nheader > ul > li[data-v-8eca63bc]:hover {\n  color: #20a0ff;\n}\nheader > ul > li:hover > a[data-v-8eca63bc] {\n  color: #20a0ff;\n}\nheader > ul > li[data-v-8eca63bc]:hover:after {\n  content: '';\n  height: 2px;\n  width: 112px;\n  background: #20a0ff;\n  display: block;\n  position: absolute;\n  left: 0;\n  top: 35px;\n}\nheader > ul > li:hover:after > a[data-v-8eca63bc] {\n  color: #20a0ff;\n}\nheader > ul > .active[data-v-8eca63bc] {\n  color: #20a0ff;\n}\nheader > ul > .active > a[data-v-8eca63bc] {\n  color: #20a0ff;\n}\nheader > ul > .active[data-v-8eca63bc]:after {\n  content: \"\";\n  height: 2px;\n  width: 112px;\n  background: #20a0ff;\n  display: block;\n  position: absolute;\n  left: 0;\n  top: 35px;\n}\nheader > ul > .active:after > a[data-v-8eca63bc] {\n  color: #20a0ff;\n}\nheader > .logOut[data-v-8eca63bc] {\n  font-size: 18px;\n  float: right;\n  margin-top: 25px;\n  height: 30px;\n  line-height: 35px;\n  margin-right: 30px;\n  cursor: pointer;\n  color: #ccc;\n}\nheader > .logOut[data-v-8eca63bc]:hover {\n  border-bottom: 1px solid #ccc;\n}\n", ""]);

// exports


/***/ }),
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 225 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 226 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(262)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(143),
  /* template */
  __webpack_require__(247),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/home/jenkins/workspace/vue-reginalAgent/node_modules/vue-quill-editor/src/editor.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] editor.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-07228def", Component.options)
  } else {
    hotAPI.reload("data-v-07228def", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(147),
  /* template */
  __webpack_require__(254),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/home/jenkins/workspace/vue-reginalAgent/src/pages/aliyunkfRegister.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] aliyunkfRegister.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6383a59e", Component.options)
  } else {
    hotAPI.reload("data-v-6383a59e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(148),
  /* template */
  __webpack_require__(260),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/home/jenkins/workspace/vue-reginalAgent/src/pages/download.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] download.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-b29841b2", Component.options)
  } else {
    hotAPI.reload("data-v-b29841b2", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(149),
  /* template */
  __webpack_require__(252),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/home/jenkins/workspace/vue-reginalAgent/src/pages/login.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] login.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-52a032da", Component.options)
  } else {
    hotAPI.reload("data-v-52a032da", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(150),
  /* template */
  __webpack_require__(250),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/home/jenkins/workspace/vue-reginalAgent/src/pages/myService.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] myService.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-51bbc65a", Component.options)
  } else {
    hotAPI.reload("data-v-51bbc65a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(263)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(151),
  /* template */
  __webpack_require__(253),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/home/jenkins/workspace/vue-reginalAgent/src/pages/providerBankCard.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] providerBankCard.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5fa77d9c", Component.options)
  } else {
    hotAPI.reload("data-v-5fa77d9c", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(152),
  /* template */
  __webpack_require__(255),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/home/jenkins/workspace/vue-reginalAgent/src/pages/providerHasLogin.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] providerHasLogin.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6841899f", Component.options)
  } else {
    hotAPI.reload("data-v-6841899f", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(153),
  /* template */
  __webpack_require__(249),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/home/jenkins/workspace/vue-reginalAgent/src/pages/providerLogin.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] providerLogin.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-49d502e9", Component.options)
  } else {
    hotAPI.reload("data-v-49d502e9", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(154),
  /* template */
  __webpack_require__(259),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/home/jenkins/workspace/vue-reginalAgent/src/pages/providerRegister.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] providerRegister.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-aca27d5a", Component.options)
  } else {
    hotAPI.reload("data-v-aca27d5a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(155),
  /* template */
  __webpack_require__(246),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/home/jenkins/workspace/vue-reginalAgent/src/pages/register.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] register.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0262807c", Component.options)
  } else {
    hotAPI.reload("data-v-0262807c", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(156),
  /* template */
  __webpack_require__(256),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/home/jenkins/workspace/vue-reginalAgent/src/pages/runnability.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] runnability.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-71da5a38", Component.options)
  } else {
    hotAPI.reload("data-v-71da5a38", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(157),
  /* template */
  __webpack_require__(257),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/home/jenkins/workspace/vue-reginalAgent/src/pages/taskRegister.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] taskRegister.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-892c6332", Component.options)
  } else {
    hotAPI.reload("data-v-892c6332", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "register"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "input marginBtm"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入电话"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "iconfont icon-shouji"
  })]), _vm._v(" "), _c('div', {
    staticClass: "input marginBtm"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    attrs: {
      "type": "text",
      "placeholder": "短信验证码"
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "iconfont icon-iconzhenghe0729fuzhi93"
  }), _vm._v(" "), (_vm.recommendToken) ? _c('div', {
    staticClass: "code",
    on: {
      "click": function($event) {
        return _vm.getSignature(_vm.recommendToken)
      }
    }
  }, [_vm._v("获取")]) : (_vm.recommendCode) ? _c('div', {
    staticClass: "code",
    on: {
      "click": function($event) {
        return _vm.getSignature(_vm.recommendCode)
      }
    }
  }, [_vm._v("获取")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "input marginBtm"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "请输入密码"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "iconfont icon-mima"
  })]), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passwords),
      expression: "passwords"
    }],
    attrs: {
      "type": "password",
      "placeholder": "请重复密码"
    },
    domProps: {
      "value": (_vm.passwords)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.passwords = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "iconfont icon-mima"
  })]), _vm._v(" "), (_vm.recommendToken) ? _c('button', {
    attrs: {
      "type": "botton"
    },
    on: {
      "click": _vm.register
    }
  }, [_vm._v("注册")]) : (_vm.recommendCode) ? _c('button', {
    attrs: {
      "type": "botton"
    },
    on: {
      "click": _vm.referralRegister
    }
  }, [_vm._v("注册")]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner"
  }, [_c('img', {
    attrs: {
      "src": "static/img/banner.png"
    }
  })])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0262807c", module.exports)
  }
}

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "quill-editor"
  }, [_vm._t("toolbar"), _vm._v(" "), _c('div', {
    ref: "editor"
  })], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-07228def", module.exports)
  }
}

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.pages) ? _c('div', {
    staticClass: "tj-pagination js-pager"
  }, [(!_vm.prePage) ? [_c('a', {
    staticClass: "start disabled",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("首页")]), _vm._v(" "), _c('a', {
    staticClass: "prev disabled",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("上一页")])] : [_c('a', {
    staticClass: "start",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.pageOffset(1)
      }
    }
  }, [_vm._v("首页")]), _vm._v(" "), _c('a', {
    staticClass: "prev",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.goPrePage
    }
  }, [_vm._v("上一页")])], _vm._v(" "), _vm._l((_vm.showPageBtn), function(i) {
    return [(i) ? _c('a', {
      class: i === _vm.pageNum ? 'disabled current' : '',
      on: {
        "click": function($event) {
          return _vm.pageOffset(i)
        }
      }
    }, [_vm._v(_vm._s(i))]) : _c('span', [_vm._v("···")])]
  }), _vm._v(" "), (!_vm.nextPage) ? [_c('a', {
    staticClass: "next disabled",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("下一页")]), _vm._v(" "), _c('a', {
    staticClass: "end disabled",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("尾页")])] : [_c('a', {
    staticClass: "next",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.goNextPage
    }
  }, [_vm._v("下一页")]), _vm._v(" "), _c('a', {
    staticClass: "end",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.pageOffset(_vm.pages)
      }
    }
  }, [_vm._v("尾页")])]], 2) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0c29ce2f", module.exports)
  }
}

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "providerRegister"
  }, [_vm._m(0), _vm._v(" "), _c('h3', [_vm._v("登录")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "input"
  }, [_c('span', [_vm._v("手机号")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.loginName),
      expression: "loginName"
    }],
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "placeholder": "请输入手机号码"
    },
    domProps: {
      "value": (_vm.loginName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.loginName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [_c('span', [_vm._v("密码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.loginPwd),
      expression: "loginPwd"
    }],
    attrs: {
      "type": "password",
      "autocomplete": "new-password",
      "placeholder": "请输入密码"
    },
    domProps: {
      "value": (_vm.loginPwd)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.loginPwd = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn-blue",
    on: {
      "click": _vm.providerLogin
    }
  }, [_vm._v("登录")]), _vm._v(" "), _c('p', {
    staticClass: "tologin"
  }, [_c('a', {
    attrs: {
      "href": '/reginalAgent/providerRegister?providerCode=' + _vm.providerCode
    }
  }, [_vm._v("返回注册")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner"
  }, [_c('img', {
    attrs: {
      "src": "static/img/provider-bg.png"
    }
  })])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-49d502e9", module.exports)
  }
}

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "myservice"
  }, [_c('Vueheader', {
    attrs: {
      "addActive": _vm.addActive
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "search"
  }, [_c('div', {
    staticClass: "state"
  }, [_c('p', [_vm._v("当前状态")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "170px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.tjkTaskApplyState),
      callback: function($$v) {
        _vm.tjkTaskApplyState = $$v
      },
      expression: "tjkTaskApplyState"
    }
  }, _vm._l((_vm.taskOptions), function(t) {
    return _c('el-option', {
      key: t.value,
      attrs: {
        "label": t.label,
        "value": t.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "state"
  }, [_c('p', [_vm._v("客服")]), _vm._v(" "), _c('el-autocomplete', {
    staticClass: "inline-input",
    attrs: {
      "fetch-suggestions": _vm.tjkSearch,
      "placeholder": "请输入姓名或登录账号",
      "trigger-on-focus": false
    },
    on: {
      "select": _vm.tjkHandleSelect
    },
    model: {
      value: (_vm.tjkName),
      callback: function($$v) {
        _vm.tjkName = $$v
      },
      expression: "tjkName"
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.searchOwnedTjk(1)
      }
    }
  }, [_vm._v("查询")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "contentList"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.serviceList), function(item, key) {
    return _c('ul', {
      class: {
        'active': key % 2 != 1
      }
    }, [_c('li', {
      staticClass: "name border"
    }, [_vm._v(_vm._s(item.tjkuser.realName))]), _vm._v(" "), _c('li', {
      staticClass: "phone border"
    }, [_vm._v(_vm._s(item.tjkuser.loginName))]), _vm._v(" "), _c('li', {
      staticClass: "joinDate border"
    }, [_vm._v(_vm._s(item.createDate))]), _vm._v(" "), _c('li', {
      staticClass: "currentState border"
    }, [(item.tjkStatus == 'WaitTrained') ? _c('span', [_vm._v("待培训")]) : _vm._e(), _vm._v(" "), (item.tjkStatus == 'Training') ? _c('span', [_vm._v("培训中")]) : _vm._e(), _vm._v(" "), (item.tjkStatus == 'ForPost') ? _c('span', [_vm._v("培训完毕待上岗")]) : _vm._e(), _vm._v(" "), (item.tjkStatus == 'InPost') ? _c('span', [_vm._v("已上岗")]) : _vm._e()]), _vm._v(" "), _c('li', {
      staticClass: "workTime border"
    }, [_vm._v(_vm._s(item.workHour) + "H")]), _vm._v(" "), _c('li', {
      staticClass: "handle"
    }, [(item.tjkStatus == 'WaitTrained') ? _c('a', {
      staticClass: "handle",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.updateTjkStatus(item.tjkuser.id, 'Training')
        }
      }
    }, [_vm._v("标记开始培训")]) : (item.tjkStatus == 'Training') ? _c('a', {
      staticClass: "handle",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.updateTjkStatus(item.tjkuser.id, 'ForPost')
        }
      }
    }, [_vm._v("标记已培训完结")]) : _vm._e()])])
  }), _vm._v(" "), [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.serviceList == null || _vm.serviceList.length == 0),
      expression: "serviceList == null || serviceList.length == 0"
    }],
    staticClass: "noRecord"
  }, [_vm._v("暂无记录")])], _vm._v(" "), _c('pagination', {
    attrs: {
      "pages": _vm.pages,
      "pageNum": _vm.pageNum
    },
    on: {
      "getData": _vm.searchOwnedTjk
    }
  })], 2)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticStyle: {
      "background": "#d1dbe5"
    }
  }, [_c('li', {
    staticClass: "name border"
  }, [_vm._v("客服姓名")]), _vm._v(" "), _c('li', {
    staticClass: "phone border"
  }, [_vm._v("登录账号")]), _vm._v(" "), _c('li', {
    staticClass: "joinDate border"
  }, [_vm._v("注册时间")]), _vm._v(" "), _c('li', {
    staticClass: "currentState border"
  }, [_vm._v("当前状态")]), _vm._v(" "), _c('li', {
    staticClass: "workTime border"
  }, [_vm._v("上岗时长")]), _vm._v(" "), _c('li', {
    staticClass: "handle"
  }, [_vm._v("操作")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-51bbc65a", module.exports)
  }
}

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('main', [_c('router-view', {
    directives: [{
      name: "wechat-title",
      rawName: "v-wechat-title",
      value: (_vm.$route.meta.title),
      expression: "$route.meta.title"
    }]
  })], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-52508dfd", module.exports)
  }
}

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_c('div', {
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "txt"
  }, [_c('div', {
    staticClass: "all account"
  }, [_c('span', [_vm._v("账号：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.account),
      expression: "account"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入账号"
    },
    domProps: {
      "value": (_vm.account)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.account = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "all password"
  }, [_c('span', [_vm._v("密码：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "autocomplete": "new-password",
      "placeholder": "请输入密码"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("登录")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": "static/img/logo1.png"
    }
  }), _vm._v(" "), _c('p', [_vm._v("淘金区域代理")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-52a032da", module.exports)
  }
}

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "providerBankCard"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "bank-box"
  }, [_c('p', [_vm._v("实名认证")]), _vm._v(" "), (!_vm.hasReal) ? [_c('p', {
    staticClass: "tips"
  }, [_vm._v("* 实名认证后不能修改，请如实填写")])] : _vm._e(), _vm._v(" "), (_vm.hasReal) ? [_c('div', {
    staticClass: "input-box"
  }, [_vm._m(1), _vm._v("\n\t\t\t\t\t" + _vm._s(_vm.idCardName) + "\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_vm._m(2), _vm._v("\n\t\t\t\t\t" + _vm._s(_vm.idCardNumber) + "\n\t\t\t\t")])] : [_c('div', {
    staticClass: "input-box"
  }, [_vm._m(3), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.idCardName),
      expression: "idCardName"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入真实姓名"
    },
    domProps: {
      "value": (_vm.idCardName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.idCardName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_vm._m(4), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.idCardNumber),
      expression: "idCardNumber"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入身份证号码"
    },
    domProps: {
      "value": (_vm.idCardNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.idCardNumber = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('div', {
    staticClass: "idcard"
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": _vm.uploadUrl,
      "show-file-list": false,
      "http-request": _vm.uploadFront
    }
  }, [(_vm.imageUrlFront) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.imageUrlFront
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })]), _vm._v(" "), _c('p', [_vm._v("身份证正面")])], 1), _vm._v(" "), _c('div', {
    staticClass: "idcard"
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": _vm.uploadUrl,
      "show-file-list": false,
      "http-request": _vm.uploadBack
    }
  }, [(_vm.imageUrlBack) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.imageUrlBack
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })]), _vm._v(" "), _c('p', [_vm._v("身份证反面")])], 1)])], _vm._v(" "), _c('p', [_vm._v("请绑定持卡人本人的银行卡")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('span', [_vm._v("卡号")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cashAccount),
      expression: "cashAccount"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入银行卡号"
    },
    domProps: {
      "value": (_vm.cashAccount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cashAccount = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('span', [_vm._v("开户行名称")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "170px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "请选择开户银行"
    },
    model: {
      value: (_vm.bankId),
      callback: function($$v) {
        _vm.bankId = $$v
      },
      expression: "bankId"
    }
  }, _vm._l((_vm.bankList), function(b, key) {
    return _c('el-option', {
      key: b.id,
      attrs: {
        "label": b.name,
        "value": b.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('span', [_vm._v("开户行地址")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "170px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "请选择省份"
    },
    on: {
      "change": _vm.queryCitysFun
    },
    model: {
      value: (_vm.bankProvince),
      callback: function($$v) {
        _vm.bankProvince = $$v
      },
      expression: "bankProvince"
    }
  }, _vm._l((_vm.provinceList), function(item, key) {
    return _c('el-option', {
      key: item.provinceName,
      attrs: {
        "label": item.provinceName,
        "value": item.provinceName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('span', [_vm._v(" ")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "170px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "请选择地市"
    },
    model: {
      value: (_vm.bankCity),
      callback: function($$v) {
        _vm.bankCity = $$v
      },
      expression: "bankCity"
    }
  }, _vm._l((_vm.citysList), function(item, key) {
    return _c('el-option', {
      key: item.citysName,
      attrs: {
        "label": item.citysName,
        "value": item.citysName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bankArea),
      expression: "bankArea"
    }],
    staticClass: "single",
    attrs: {
      "type": "text",
      "placeholder": "请填写是什么支行，如：高新支行"
    },
    domProps: {
      "value": (_vm.bankArea)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bankArea = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.bankStatus == 0) ? [_c('p', {
    staticClass: "text-blue",
    on: {
      "click": _vm.deleteCard
    }
  }, [_vm._v("解除绑定银行卡")]), _vm._v(" "), _c('p', {
    staticClass: "tips"
  }, [_vm._v("* 银行卡信息必须和实名信息一致，如需更改银行卡信息，请解除绑定后重新绑定。")]), _vm._v(" "), _c('button', {
    staticClass: "btn-disable"
  }, [_vm._v("确认")])] : (_vm.bankStatus == 2) ? [_c('p', {
    staticClass: "text-blue",
    on: {
      "click": _vm.deleteCard
    }
  }, [_vm._v("解除绑定银行卡")]), _vm._v(" "), _c('p', {
    staticClass: "tips"
  }, [_vm._v("* 银行卡信息必须和实名信息一致，如需更改银行卡信息，请解除绑定后重新绑定。")]), _vm._v(" "), _c('button', {
    staticClass: "btn-disable"
  }, [_vm._v("确认")])] : [_c('button', {
    staticClass: "btn-blue",
    on: {
      "click": _vm.bindBankCard
    }
  }, [_vm._v("确认")])]], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('span'), _vm._v(" "), _c('span', [_vm._v("绑定银行卡")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('p', {
    staticClass: "tips",
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._v("*")]), _vm._v("真实姓名")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('p', {
    staticClass: "tips",
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._v("*")]), _vm._v("身份证号码")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('p', {
    staticClass: "tips",
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._v("*")]), _vm._v("真实姓名")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('p', {
    staticClass: "tips",
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._v("*")]), _vm._v("身份证号码")])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5fa77d9c", module.exports)
  }
}

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "register"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "hint"
  }, [_vm._v("注册后可以查看更多任务哦!")]), _vm._v(" "), _c('div', {
    staticClass: "input marginBtm"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入电话"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "iconfont icon-shouji"
  })]), _vm._v(" "), _c('div', {
    staticClass: "input marginBtm"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    attrs: {
      "type": "text",
      "placeholder": "短信验证码"
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "iconfont icon-iconzhenghe0729fuzhi93"
  }), _vm._v(" "), _c('div', {
    staticClass: "code",
    on: {
      "click": function($event) {
        return _vm.getSignature()
      }
    }
  }, [_vm._v("获取")])]), _vm._v(" "), _c('div', {
    staticClass: "input marginBtm"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "请输入密码"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "iconfont icon-mima"
  })]), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passwords),
      expression: "passwords"
    }],
    attrs: {
      "type": "password",
      "placeholder": "请重复密码"
    },
    domProps: {
      "value": (_vm.passwords)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.passwords = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "iconfont icon-mima"
  })]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "botton"
    },
    on: {
      "click": _vm.referralRegister
    }
  }, [_vm._v("注册")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner"
  }, [_c('img', {
    attrs: {
      "src": "static/img/provider-banner.png"
    }
  })])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6383a59e", module.exports)
  }
}

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "providerRegister"
  }, [_vm._m(0), _vm._v(" "), _c('h3', [_vm._v("修改资料")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "input"
  }, [_c('span', [_vm._v("手机号")]), _vm._v(" "), _c('span', {
    staticClass: "phone"
  }, [_vm._v(_vm._s(_vm.phone))])]), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [_c('span', [_vm._v("密码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "autocomplete": "new-password",
      "placeholder": "请输入密码"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-box clearfix"
  }, [_c('span', {
    staticClass: "bindCard"
  }, [_vm._v("绑定银行卡")]), _vm._v(" "), _c('div', {
    staticClass: "cardMsg"
  }, [(_vm.bankStatus == 0) ? [_c('span', {
    staticClass: "pass"
  }, [_vm._v("已绑定")])] : (_vm.bankStatus == 2) ? [_c('span', {
    staticClass: "shenhz"
  }, [_vm._v("审核中")])] : (_vm.bankStatus == 3) ? [_c('span', {
    staticClass: "nopass"
  }, [_vm._v("审核不通过")])] : [_c('span', [_vm._v("未绑定")])], _vm._v(" "), _c('a', {
    attrs: {
      "href": '/reginalAgent/providerBankCard?token=' + _vm.tjk_login_token + '&providerCode=' + _vm.providerCode + '&phone=' + _vm.phone
    }
  }, [_c('img', {
    attrs: {
      "src": "static/img/icon_right.png",
      "width": "14px"
    }
  })])], 2)]), _vm._v(" "), _c('p', {
    staticClass: "tips-content"
  }, [_vm._v(_vm._s(_vm.content))]), _vm._v(" "), _c('button', {
    staticClass: "btn-blue",
    on: {
      "click": _vm.changeFun
    }
  }, [_vm._v("确认修改")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner"
  }, [_c('img', {
    attrs: {
      "src": "static/img/provider-bg.png"
    }
  })])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6841899f", module.exports)
  }
}

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "runnability"
  }, [_c('Vueheader', {
    attrs: {
      "addActive": _vm.addActive
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "allLedger"
  }, [_c('div', {
    staticClass: "ledger active",
    on: {
      "click": _vm.statistics
    }
  }, [_c('span', {
    staticClass: "iconfont icon-ren111"
  }, [_vm._v("总推荐人")])]), _vm._v(" "), _c('div', {
    staticClass: "ledger",
    staticStyle: {
      "margin": "0 3.5%"
    },
    on: {
      "click": function($event) {
        return _vm.statistics('mount')
      }
    }
  }, [_c('span', {
    staticClass: "iconfont icon-renqun"
  }, [_vm._v("总上岗人数")])]), _vm._v(" "), _c('div', {
    staticClass: "ledger",
    on: {
      "click": function($event) {
        return _vm.statistics('duration')
      }
    }
  }, [_c('span', {
    staticClass: "iconfont icon-shijian00"
  }, [_vm._v("总服务时长")])])]), _vm._v(" "), _c('vue-highcharts', {
    ref: "lineCharts",
    attrs: {
      "options": _vm.options
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "rightcenter"
  }, [_c('img', {
    staticClass: "sharebg",
    attrs: {
      "src": "static/img/sharebg.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "rightTxt"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "static/img/logo.png"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "logotxt",
    attrs: {
      "src": "static/img/logotxt.png"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "logotext"
  }, [_vm._v("在家做客服，在家赚钱")]), _vm._v(" "), _c('p', {
    staticClass: "wenben"
  }, [_vm._v("从零开始，邀请您进入在家赚钱的淘金云客服平台")]), _vm._v(" "), _c('img', {
    staticClass: "QRcode",
    attrs: {
      "src": _vm.icon
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "discern"
  }, [_vm._v("长按识别二维码")])])])])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-71da5a38", module.exports)
  }
}

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "register"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "hint"
  }, [_vm._v("注册后可以查看更多任务哦!")]), _vm._v(" "), _c('div', {
    staticClass: "input marginBtm"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入电话"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "iconfont icon-shouji"
  })]), _vm._v(" "), _c('div', {
    staticClass: "input marginBtm"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    attrs: {
      "type": "text",
      "placeholder": "短信验证码"
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "iconfont icon-iconzhenghe0729fuzhi93"
  }), _vm._v(" "), (_vm.taskInfoCode) ? _c('div', {
    staticClass: "code",
    on: {
      "click": function($event) {
        return _vm.getSignature(_vm.taskInfoCode)
      }
    }
  }, [_vm._v("获取")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "input marginBtm"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "请输入密码"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "iconfont icon-mima"
  })]), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passwords),
      expression: "passwords"
    }],
    attrs: {
      "type": "password",
      "placeholder": "请重复密码"
    },
    domProps: {
      "value": (_vm.passwords)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.passwords = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "iconfont icon-mima"
  })]), _vm._v(" "), (_vm.taskInfoCode) ? _c('button', {
    attrs: {
      "type": "botton"
    },
    on: {
      "click": _vm.referralRegister
    }
  }, [_vm._v("注册")]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner"
  }, [_c('img', {
    attrs: {
      "src": "static/img/provider-banner.png"
    }
  })])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-892c6332", module.exports)
  }
}

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "static/img/logo1.png"
    }
  }), _vm._v(" "), _c('p', [_vm._v("淘金区域代理")]), _vm._v(" "), _c('ul', [_c('li', {
    class: {
      'active': _vm.addActive % 2 == 1
    }
  }, [_c('a', {
    attrs: {
      "href": "/reginalAgent/runnability"
    }
  }, [_vm._v("运行情况")])]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.addActive % 2 != 1
    }
  }, [_c('a', {
    attrs: {
      "href": "/reginalAgent/myService"
    }
  }, [_vm._v("我的客服")])])]), _vm._v(" "), _c('div', {
    staticClass: "logOut",
    on: {
      "click": _vm.logOut
    }
  }, [_vm._v("登出")])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-8eca63bc", module.exports)
  }
}

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "providerRegister"
  }, [_vm._m(0), _vm._v(" "), _c('h3', [_vm._v("加入我们")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "input"
  }, [_c('span', [_vm._v("手机号")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.phone),
      expression: "form.phone"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入手机号码"
    },
    domProps: {
      "value": (_vm.form.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "phone", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [_c('span', [_vm._v("密码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.password),
      expression: "form.password"
    }],
    attrs: {
      "type": "password",
      "autocomplete": "new-password",
      "placeholder": "请输入密码"
    },
    domProps: {
      "value": (_vm.form.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.providerCode),
      expression: "providerCode"
    }],
    staticClass: "btn-blue",
    on: {
      "click": _vm.providerRegister
    }
  }, [_vm._v("立即加入")]), _vm._v(" "), _c('p', {
    staticClass: "tologin"
  }, [_c('a', {
    attrs: {
      "href": '/reginalAgent/providerLogin?providerCode=' + _vm.providerCode
    }
  }, [_vm._v("已有账号？去登录")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner"
  }, [_c('img', {
    attrs: {
      "src": "static/img/provider-bg.png"
    }
  })])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-aca27d5a", module.exports)
  }
}

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "download"
  }, [_c('img', {
    staticClass: "bg",
    attrs: {
      "src": "static/img/bg.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "static/img/logo2.png"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "logotxt",
    attrs: {
      "src": "static/img/logotxt.png"
    }
  }), _vm._v(" "), _c('p', [_vm._v("注册成功")]), _vm._v(" "), _c('span', [_vm._v("如何开启赚钱第一步")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.trackEvent($event)
      }
    }
  }, [_vm._v("点击下载淘金云客服app")])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-b29841b2", module.exports)
  }
}

/***/ }),
/* 261 */,
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(203);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(57)("1326d1fe", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-07228def\",\"scoped\":false,\"hasInlineConfig\":false}!../../vue-loader/lib/selector.js?type=styles&index=0!./editor.vue", function() {
     var newContent = require("!!../../css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-07228def\",\"scoped\":false,\"hasInlineConfig\":false}!../../vue-loader/lib/selector.js?type=styles&index=0!./editor.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(204);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(57)("5b164ad5", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5fa77d9c\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./providerBankCard.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5fa77d9c\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./providerBankCard.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(205);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(57)("366c35bc", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-8eca63bc\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./header.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-8eca63bc\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/less-loader/dist/cjs.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./header.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */
/***/ (function(module, exports) {

module.exports = {"provinces":[{"citys":[{"citysName":"东城区"},{"citysName":"西城区"},{"citysName":"崇文区"},{"citysName":"宣武区"},{"citysName":"朝阳区"},{"citysName":"丰台区"},{"citysName":"石景山区"},{"citysName":"海淀区"},{"citysName":"门头沟区"},{"citysName":"房山区"},{"citysName":"通州区"},{"citysName":"顺义区"},{"citysName":"昌平区"},{"citysName":"大兴区"},{"citysName":"怀柔区"},{"citysName":"平谷区"},{"citysName":"密云县"},{"citysName":"延庆县"}],"provinceName":"北京市"},{"citys":[{"citysName":"黄浦区"},{"citysName":"卢湾区"},{"citysName":"徐汇区"},{"citysName":"长宁区"},{"citysName":"静安区"},{"citysName":"普陀区"},{"citysName":"闸北区"},{"citysName":"虹口区"},{"citysName":"杨浦区"},{"citysName":"闵行区"},{"citysName":"宝山区"},{"citysName":"嘉定区"},{"citysName":"浦东新区"},{"citysName":"金山区"},{"citysName":"松江区"},{"citysName":"青浦区"},{"citysName":"南汇区"},{"citysName":"奉贤区"},{"citysName":"崇明县"}],"provinceName":"上海市"},{"citys":[{"citysName":"和平区"},{"citysName":"河东区"},{"citysName":"河西区"},{"citysName":"南开区"},{"citysName":"河北区"},{"citysName":"红桥区"},{"citysName":"塘沽区"},{"citysName":"汉沽区"},{"citysName":"大港区"},{"citysName":"东丽区"},{"citysName":"西青区"},{"citysName":"津南区"},{"citysName":"北辰区"},{"citysName":"武清区"},{"citysName":"宝坻区"},{"citysName":"宁河县"},{"citysName":"静海县"},{"citysName":"蓟　县"}],"provinceName":"天津市"},{"citys":[{"citysName":"万州区"},{"citysName":"涪陵区"},{"citysName":"渝中区"},{"citysName":"大渡口区"},{"citysName":"江北区"},{"citysName":"沙坪坝区"},{"citysName":"九龙坡区"},{"citysName":"南岸区"},{"citysName":"北碚区"},{"citysName":"万盛区"},{"citysName":"双桥区"},{"citysName":"渝北区"},{"citysName":"巴南区"},{"citysName":"黔江区"},{"citysName":"长寿区"}],"provinceName":"重庆市"},{"citys":[{"citysName":"石家庄市"},{"citysName":"邯郸市"},{"citysName":"唐山市"},{"citysName":"保定市"},{"citysName":"秦皇岛市"},{"citysName":"邢台市"},{"citysName":"张家口市"},{"citysName":"承德市"},{"citysName":"沧州市"},{"citysName":"廊坊市"},{"citysName":"衡水市"}],"provinceName":"河北省"},{"citys":[{"citysName":"太原市"},{"citysName":"大同市"},{"citysName":"朔州市"},{"citysName":"阳泉市"},{"citysName":"长治市"},{"citysName":"晋城市"},{"citysName":"忻州市"},{"citysName":"吕梁市"},{"citysName":"晋中市"},{"citysName":"临汾市"},{"citysName":"运城市"}],"provinceName":"山西省"},{"citys":[{"citysName":"呼和浩特市"},{"citysName":"包头市"},{"citysName":"乌海市"},{"citysName":"赤峰市"},{"citysName":"呼伦贝尔市"},{"citysName":"通辽市"},{"citysName":"乌兰察布市"},{"citysName":"鄂尔多斯市"},{"citysName":"巴彦淖尔市"},{"citysName":"兴安盟"},{"citysName":"锡林郭勒盟"},{"citysName":"阿拉善盟"}],"provinceName":"内蒙古自治区"},{"citys":[{"citysName":"沈阳市"},{"citysName":"大连市"},{"citysName":"朝阳市"},{"citysName":"阜新市"},{"citysName":"铁岭市"},{"citysName":"抚顺市"},{"citysName":"本溪市"},{"citysName":"辽阳市"},{"citysName":"鞍山市"},{"citysName":"丹东市"},{"citysName":"营口市"},{"citysName":"盘锦市"},{"citysName":"锦州市"},{"citysName":"葫芦岛市"}],"provinceName":"辽宁省"},{"citys":[{"citysName":"长春市"},{"citysName":"吉林市"},{"citysName":"白城市"},{"citysName":"松原市"},{"citysName":"四平市"},{"citysName":"辽源市"},{"citysName":"通化市"},{"citysName":"白山市"},{"citysName":"延边朝鲜族自治州"}],"provinceName":"吉林省"},{"citys":[{"citysName":"哈尔滨市"},{"citysName":"齐齐哈尔市"},{"citysName":"黑河市"},{"citysName":"大庆市"},{"citysName":"伊春市"},{"citysName":"鹤岗市"},{"citysName":"佳木斯市"},{"citysName":"双鸭山市"},{"citysName":"七台河市"},{"citysName":"鸡西市"},{"citysName":"牡丹江市"},{"citysName":"绥化市"},{"citysName":"大兴安岭地区"}],"provinceName":"黑龙江省"},{"citys":[{"citysName":"南京市"},{"citysName":"徐州市"},{"citysName":"连云港市"},{"citysName":"宿迁市"},{"citysName":"淮安市"},{"citysName":"盐城市"},{"citysName":"扬州市"},{"citysName":"泰州市"},{"citysName":"南通市"},{"citysName":"镇江市"},{"citysName":"常州市"},{"citysName":"无锡市"},{"citysName":"苏州市"}],"provinceName":"江苏省"},{"citys":[{"citysName":"杭州市"},{"citysName":"宁波市"},{"citysName":"湖州市"},{"citysName":"嘉兴市"},{"citysName":"舟山市"},{"citysName":"绍兴市"},{"citysName":"衢州市"},{"citysName":"金华市"},{"citysName":"台州市"},{"citysName":"温州市"},{"citysName":"丽水市"}],"provinceName":"浙江省"},{"citys":[{"citysName":"合肥市"},{"citysName":"芜湖市"},{"citysName":"蚌埠市"},{"citysName":"淮南市"},{"citysName":"马鞍山市"},{"citysName":"淮北市"},{"citysName":"铜陵市"},{"citysName":"安庆市"},{"citysName":"黄山市"},{"citysName":"滁州市"},{"citysName":"阜阳市"},{"citysName":"宿州市"},{"citysName":"六安市"},{"citysName":"亳州市"},{"citysName":"池州市"},{"citysName":"宣城市"},{"citysName":"巢湖市"}],"provinceName":"安徽省"},{"citys":[{"citysName":"厦门市"},{"citysName":"福州市"},{"citysName":"南平市"},{"citysName":"三明市"},{"citysName":"莆田市"},{"citysName":"泉州市"},{"citysName":"漳州市"},{"citysName":"龙岩市"},{"citysName":"宁德市"}],"provinceName":"福建省"},{"citys":[{"citysName":"南昌市"},{"citysName":"九江市"},{"citysName":"景德镇市"},{"citysName":"鹰潭市"},{"citysName":"新余市"},{"citysName":"萍乡市"},{"citysName":"赣州市"},{"citysName":"上饶市"},{"citysName":"抚州市"},{"citysName":"宜春市"},{"citysName":"吉安市"}],"provinceName":"江西省"},{"citys":[{"citysName":"济南市"},{"citysName":"青岛市"},{"citysName":"聊城市"},{"citysName":"德州市"},{"citysName":"东营市"},{"citysName":"淄博市"},{"citysName":"潍坊市"},{"citysName":"烟台市"},{"citysName":"威海市"},{"citysName":"日照市"},{"citysName":"临沂市"},{"citysName":"枣庄市"},{"citysName":"济宁市"},{"citysName":"泰安市"},{"citysName":"莱芜市"},{"citysName":"滨州市"},{"citysName":"菏泽市"}],"provinceName":"山东省"},{"citys":[{"citysName":"郑州市"},{"citysName":"开封市"},{"citysName":"洛阳市"},{"citysName":"平顶山市"},{"citysName":"安阳市"},{"citysName":"鹤壁市"},{"citysName":"新乡市"},{"citysName":"焦作市"},{"citysName":"濮阳市"},{"citysName":"许昌市"},{"citysName":"漯河市"},{"citysName":"三门峡市"},{"citysName":"南阳市"},{"citysName":"商丘市"},{"citysName":"周口市"},{"citysName":"驻马店市"},{"citysName":"信阳市"}],"provinceName":"河南省"},{"citys":[{"citysName":"武汉市"},{"citysName":"十堰市"},{"citysName":"襄阳市"},{"citysName":"荆门市"},{"citysName":"孝感市"},{"citysName":"黄冈市"},{"citysName":"鄂州市"},{"citysName":"黄石市"},{"citysName":"咸宁市"},{"citysName":"荆州市"},{"citysName":"宜昌市"},{"citysName":"随州市"},{"citysName":"恩施土家族苗族自治州"}],"provinceName":"湖北省"},{"citys":[{"citysName":"长沙市"},{"citysName":"衡阳市"},{"citysName":"张家界市"},{"citysName":"常德市"},{"citysName":"益阳市"},{"citysName":"岳阳市"},{"citysName":"株洲市"},{"citysName":"湘潭市"},{"citysName":"郴州市"},{"citysName":"永州市"},{"citysName":"邵阳市"},{"citysName":"怀化市"},{"citysName":"娄底市"},{"citysName":"湘西土家族苗族自治州"}],"provinceName":"湖南省"},{"citys":[{"citysName":"广州市"},{"citysName":"深圳市"},{"citysName":"清远市"},{"citysName":"韶关市"},{"citysName":"河源市"},{"citysName":"梅州市"},{"citysName":"潮州市"},{"citysName":"汕头市"},{"citysName":"揭阳市"},{"citysName":"汕尾市"},{"citysName":"惠州市"},{"citysName":"东莞市"},{"citysName":"珠海市"},{"citysName":"中山市"},{"citysName":"江门市"},{"citysName":"佛山市"},{"citysName":"肇庆市"},{"citysName":"云浮市"},{"citysName":"阳江市"},{"citysName":"茂名市"},{"citysName":"湛江市"}],"provinceName":"广东省"},{"citys":[{"citysName":"南宁市"},{"citysName":"桂林市"},{"citysName":"柳州市"},{"citysName":"梧州市"},{"citysName":"贵港市"},{"citysName":"玉林市"},{"citysName":"钦州市"},{"citysName":"北海市"},{"citysName":"防城港市"},{"citysName":"崇左市"},{"citysName":"百色市"},{"citysName":"河池市"},{"citysName":"来宾市"},{"citysName":"贺州市"}],"provinceName":"广西壮族自治区"},{"citys":[{"citysName":"海口市"},{"citysName":"三亚市"}],"provinceName":"海南省"},{"citys":[{"citysName":"成都市"},{"citysName":"广元市"},{"citysName":"绵阳市"},{"citysName":"德阳市"},{"citysName":"南充市"},{"citysName":"广安市"},{"citysName":"遂宁市"},{"citysName":"内江市"},{"citysName":"乐山市"},{"citysName":"自贡市"},{"citysName":"泸州市"},{"citysName":"宜宾市"},{"citysName":"攀枝花市"},{"citysName":"巴中市"},{"citysName":"达州市"},{"citysName":"资阳市"},{"citysName":"眉山市"},{"citysName":"雅安市"},{"citysName":"凉山彝族自治州"},{"citysName":"阿坝藏族羌族自治州"},{"citysName":"凉山彝族自治州"}],"provinceName":"四川省"},{"citys":[{"citysName":"贵阳市"},{"citysName":"六盘水市"},{"citysName":"遵义市"},{"citysName":"安顺市"},{"citysName":"毕节市"},{"citysName":"铜仁市"},{"citysName":"黔西南布依族苗族自治州"},{"citysName":"黔东南苗族侗族自治州"},{"citysName":"黔南布依族苗族自治州"}],"provinceName":"贵州省"},{"citys":[{"citysName":"昆明市"},{"citysName":"曲靖市"},{"citysName":"玉溪市"},{"citysName":"丽江市"},{"citysName":"昭通市"},{"citysName":"思茅市"},{"citysName":"临沧市"},{"citysName":"保山市"},{"citysName":"楚雄彝族自治州"},{"citysName":"红河哈尼族彝族自治州"},{"citysName":"文山壮族苗族自治州"},{"citysName":"西双版纳傣族自治州"},{"citysName":"大理白族自治州"},{"citysName":"德宏傣族景颇族自治州"},{"citysName":"怒江傈僳族自治州"},{"citysName":"迪庆藏族自治州"}],"provinceName":"云南省"},{"citys":[{"citysName":"西安市"},{"citysName":"延安市"},{"citysName":"铜川市"},{"citysName":"渭南市"},{"citysName":"咸阳市"},{"citysName":"宝鸡市"},{"citysName":"汉中市"},{"citysName":"榆林市"},{"citysName":"商洛市"},{"citysName":"安康市"}],"provinceName":"陕西省"},{"citys":[{"citysName":"兰州市"},{"citysName":"嘉峪关市"},{"citysName":"金昌市"},{"citysName":"白银市"},{"citysName":"天水市"},{"citysName":"酒泉市"},{"citysName":"张掖市"},{"citysName":"武威市"},{"citysName":"庆阳市"},{"citysName":"平凉市"},{"citysName":"定西市"},{"citysName":"陇南市"},{"citysName":"临夏回族自治州"},{"citysName":"甘南藏族自治州"}],"provinceName":"甘肃省"},{"citys":[{"citysName":"西宁市"},{"citysName":"海东地区"},{"citysName":"海北藏族自治州"},{"citysName":"黄南藏族自治州"},{"citysName":"海南藏族自治州"},{"citysName":"果洛藏族自治州"},{"citysName":"玉树藏族自治州"},{"citysName":"海西蒙古族藏族自治州"}],"provinceName":"青海省"},{"citys":[{"citysName":"拉萨市"},{"citysName":"日喀则地区"},{"citysName":"昌都地区"},{"citysName":"那曲地区"},{"citysName":"山南地区"},{"citysName":"阿里地区"},{"citysName":"林芝地区"}],"provinceName":"西藏自治区"},{"citys":[{"citysName":"银川市"},{"citysName":"石嘴山市"},{"citysName":"吴忠市"},{"citysName":"中卫市"},{"citysName":"固原市"}],"provinceName":"宁夏回族自治区"},{"citys":[{"citysName":"乌鲁木齐市"},{"citysName":"克拉玛依市"},{"citysName":"吐鲁番市"},{"citysName":"哈密市"},{"citysName":"昌吉回族自治州"},{"citysName":"博尔塔拉蒙古自治州"},{"citysName":"巴音郭楞蒙古自治州"},{"citysName":"阿克苏地区"},{"citysName":"克孜勒苏柯尔克孜自治州"},{"citysName":"喀什地区"},{"citysName":"和田地区"},{"citysName":"伊犁哈萨克自治州"},{"citysName":"塔城地区"},{"citysName":"阿勒泰地区"}],"provinceName":"新疆维吾尔自治区"},{"citys":[{"citysName":"台北市"},{"citysName":"新北市"},{"citysName":"桃园市"},{"citysName":"台中市"},{"citysName":"台南市"},{"citysName":"高雄市"},{"citysName":"基隆市"},{"citysName":"新竹市"},{"citysName":"嘉义市"}],"provinceName":"台湾"},{"citys":[{"citysName":"香港特别行政区"}],"provinceName":"香港"},{"citys":[{"citysName":"澳门特别行政区"}],"provinceName":"澳门"}]}

/***/ })
]),[158]);


// WEBPACK FOOTER //
// static/js/app.f42c6485721f79c62683.js